<template>
  <div class="h-100">
    <Layout ref="layout" :full="true">
      <template v-slot:body>
        <div class="h-100 w-100 map">
          <GoogleMap ref="map" mapTypeId="roadmap" :showMapTypeToggle="true">
            <template v-slot:body>
              <div class="w-100 h-100">
                <MapSearchBox v-if="menuType === 'clima'" :map="$refs.map ? $refs.map.map : null" />
                <!-- NEW ASIDE -->
                <NewAside v-if="useNewAside" ref="aside" @close="asideClose" @show="showAside">
                  <template v-slot:body>
                    <NewAsideClimate
                      ref="aside_clima"
                      :key="'aside_clima_' + (asideClimaKey || 0)"
                      v-if="menuType == 'clima'"
                    ></NewAsideClimate>
                    <!-- Antes das demais camadas: o aviso é o único item do painel que não
                         é um ponto do mapa, e abrir um zera a seleção de ponto (ver
                         abrirAvisoInmet), então esta condição não concorre com as outras. -->
                    <NewAsideInmetAviso
                      v-else-if="avisoInmetSelecionado"
                      :aviso="avisoInmetSelecionado"
                    ></NewAsideInmetAviso>
                    <NewAsideDefesaCivil
                      ref="aside_defesacivil"
                      v-else-if="selectedIsDefesaCivil"
                    ></NewAsideDefesaCivil>
                    <NewAsideExternalDevice
                      ref="aside_externo"
                      v-else-if="selectedIsExternal"
                    ></NewAsideExternalDevice>
                    <NewAsideDevice
                      ref="aside_estacao"
                      v-else
                    ></NewAsideDevice>
                  </template>
                </NewAside>
                <!-- OLD ASIDE (legacy) -->
                <Aside v-else ref="aside" @close="asideClose" @show="showAside">
                  <template v-slot:body>
                    <AsideClima
                      @info="
                        d.detalhado
                          ? ($refs.aside.footerButton = {
                              name: 'Dados detalhados',
                              icon: 'fa fa-circle-info',
                            })
                          : null
                      "
                      ref="aside_clima"
                      :key="'aside_clima_' + (asideClimaKey || 0)"
                      v-if="menuType == 'clima'"
                    ></AsideClima>
                    <AsideEstacaoSimples
                      ref="aside_estacao"
                      v-else
                    ></AsideEstacaoSimples>
                  </template>
                </Aside>
                <div class="w-100 h-100">
                  <div class="map-load" v-if="loadMap">
                    <div class="m-auto text-center">
                      <Load></Load>
                    </div>
                  </div>
                  <div v-if="menuType == 'clima'">
                    <div class="div-btn-mapa">
                      <button
                        :title="b.title"
                        v-for="(b, i) in climaBotoes"
                        :key="i"
                        :class="
                          'btn-mapa' + (b.value == climaType ? ' active' : '')
                        "
                        @click="climaType = b.value"
                      >
                        <font-awesome-icon
                          class="icone-card-clima"
                          :icon="b.icon"
                        />
                      </button>
                    </div>
                  </div>
                  <!-- Modo Público: botão dos avisos do INMET, botão da Defesa Civil (RS)
                       e, com esta ligada, um botão por grandeza — mesma coluna e mesmo
                       desenho dos botões do modo Previsão. -->
                  <div v-else-if="menuType == 'publico'">
                    <!-- Um ÚNICO .div-btn-mapa para as duas camadas: a classe é
                         position:absolute com top fixo, então dois blocos irmãos se
                         sobrepõem no mesmo ponto em vez de empilhar. Os botões são irmãos
                         dentro do mesmo container, como no modo Previsão. -->
                    <div
                      class="div-btn-mapa"
                      v-if="podeVerInmet || podeVerDefesaCivil"
                    >
                      <!-- Avisos do INMET: camada de POLÍGONOS, acima da Defesa Civil. -->
                      <button
                        v-if="podeVerInmet"
                        type="button"
                        title="Avisos meteorológicos do INMET"
                        :class="'btn-mapa btn-mapa-inmet' + (inmetAtivo ? ' active' : '')"
                        @click="inmetAtivo = !inmetAtivo"
                      >
                        <font-awesome-icon
                          class="icone-card-clima"
                          icon="fa fa-triangle-exclamation"
                        />
                      </button>

                      <button
                        v-if="podeVerDefesaCivil"
                        type="button"
                        title="Defesa Civil (RS) — Rede Hidrometeorológica"
                        :class="'btn-mapa btn-mapa-dc' + (defesaCivilAtivo ? ' active' : '')"
                        @click="defesaCivilAtivo = !defesaCivilAtivo"
                      >
                        <!-- Brasão oficial da Defesa Civil (RS) em vez de um ícone
                             genérico: a camada é de uma rede de terceiros, e o selo do
                             órgão identifica a fonte melhor que um escudo qualquer. -->
                        <img
                          class="btn-mapa-brasao"
                          :src="defesaCivilBrasao"
                          alt="Defesa Civil (RS)"
                        />
                      </button>

                      <!-- Com a camada desligada não há ponto na tela para os botões de
                           grandeza mudarem, então eles só aparecem junto com ela. -->
                      <template v-if="defesaCivilAtivo">
                        <div class="btn-mapa-sep"></div>
                        <button
                          type="button"
                          v-for="b in defesaCivilBotoes"
                          :key="b.value"
                          :title="b.title"
                          :class="
                            'btn-mapa' + (b.value == defesaCivilGrandeza ? ' active' : '')
                          "
                          @click="defesaCivilGrandeza = b.value"
                        >
                          <font-awesome-icon
                            class="icone-card-clima"
                            :icon="b.icon"
                          />
                        </button>
                      </template>
                    </div>
                  </div>
                  <div v-else>
                    <div class="div-btn-mapa">
                      <button
                        style="display: none"
                        :title="b.title"
                        v-for="(b, i) in estacaoBotoes"
                        :key="i"
                        :class="
                          'btn-mapa' + (b.value == estacaoType ? ' active' : '')
                        "
                        @click="estacaoType = b.value"
                      >
                        <font-awesome-icon
                          class="icone-card-clima"
                          :icon="b.icon"
                        />
                      </button>
                    </div>
                  </div>

                  <!-- Legenda da camada do INMET. Sem ela as manchas coloridas no mapa não
                       significam nada: a cor é o único indicador de gravidade, e ela vem do
                       INMET, não de uma paleta nossa. -->
                  <div
                    class="inmet-legenda"
                    v-if="menuType == 'publico' && inmetAtivo && podeVerInmet"
                  >
                    <div class="inmet-legenda-titulo">
                      <font-awesome-icon icon="fa fa-triangle-exclamation" />
                      <span>Avisos do INMET</span>
                    </div>

                    <!-- Seletor de dia. O INMET publica avisos para hoje e para os próximos
                         dias; desenhar todos juntos empilha polígonos de datas diferentes
                         sem como distinguir a qual dia cada mancha pertence. -->
                    <div class="inmet-dias" v-if="inmetDias.length > 1">
                      <button
                        type="button"
                        v-for="d in inmetDias"
                        :key="d.dia"
                        :title="tituloDiaInmet(d)"
                        :class="[
                          'inmet-dia',
                          { active: d.dia === inmetDiaSelecionado },
                        ]"
                        @click="selecionarDiaInmet(d.dia)"
                      >
                        <span class="inmet-dia-label">{{ rotuloDiaInmet(d.dia) }}</span>
                        <span class="inmet-dia-qtd">{{ d.quantidade }}</span>
                      </button>
                    </div>

                    <div v-if="inmetCarregando" class="inmet-legenda-vazio">
                      Carregando avisos...
                    </div>
                    <div
                      v-else-if="!avisosInmetVigentes.length"
                      class="inmet-legenda-vazio"
                    >
                      {{
                        avisosInmetFuturos.length
                          ? "Nenhum aviso em vigor agora."
                          : "Nenhum aviso neste dia."
                      }}
                    </div>

                    <div
                      v-for="s in inmetResumoSeveridades"
                      :key="s.id"
                      class="inmet-legenda-item"
                    >
                      <span
                        class="inmet-legenda-cor"
                        :style="{ backgroundColor: s.cor }"
                      ></span>
                      <span class="inmet-legenda-label">{{ s.label }}</span>
                      <span class="inmet-legenda-qtd">{{ s.quantidade }}</span>
                    </div>

                    <!-- Os futuros aparecem só com contorno no mapa; a legenda explica o
                         que esse contorno vazado quer dizer. -->
                    <div
                      v-if="avisosInmetFuturos.length"
                      class="inmet-legenda-item inmet-legenda-futuro"
                    >
                      <span class="inmet-legenda-cor is-futuro"></span>
                      <span class="inmet-legenda-label">Ainda não começou</span>
                      <span class="inmet-legenda-qtd">
                        {{ avisosInmetFuturos.length }}
                      </span>
                    </div>

                    <!-- Conteúdo de uma coleta que falhou: o usuário precisa saber que o
                         dado pode estar velho antes de decidir algo com base nele. -->
                    <div v-if="inmetDegradado" class="inmet-legenda-degradado">
                      <font-awesome-icon icon="fa fa-circle-exclamation" />
                      <span>Sem atualização recente do INMET</span>
                    </div>
                    <div
                      v-else-if="inmetAtualizadoEm"
                      class="inmet-legenda-hora"
                    >
                      Atualizado às {{ formatarHoraInmet(inmetAtualizadoEm) }}
                    </div>
                  </div>

                  <div class="div-btn-mapa-bottom">
                    <div class="map-mode-toggle">
                      <div
                        v-for="(b, i) in menuBotoesVisiveis"
                        :key="i"
                        :title="b.title"
                        :class="['map-mode-option', { active: b.value == menuType }]"
                        @click="trocarModo(b)"
                      >
                        <font-awesome-icon
                          v-if="b.icon"
                          class="map-mode-icon"
                          :icon="b.icon"
                        />
                        <LogoIcon v-if="b.eicon" class="map-mode-icon"></LogoIcon>
                        <PublicIcon v-if="b.picon" class="map-mode-icon"></PublicIcon>
                        <span v-if="b.value === menuType" class="map-mode-label">
                          {{ b.title }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <!-- Ao lado do switch Terreno/Satélite: agrupamento dos pins sobrepostos. Há
                 quem prefira os grupos e quem prefira ver todos os pins; a escolha fica
                 salva no navegador. Só no modo Dispositivos — os outros não agrupam. -->
            <template v-slot:mapTypeExtra>
              <button
                v-if="menuType === 'estacao'"
                type="button"
                :title="agruparPins ? 'Agrupamento ligado — clique para ver todos os pins' : 'Agrupamento desligado — clique para agrupar os pins'"
                :class="['btn-agrupar', { active: agruparPins }]"
                @click="agruparPins = !agruparPins"
              >
                <font-awesome-icon icon="fa fa-object-group" />
              </button>
            </template>
            <template v-slot:point="data">
              <ClimaPonto :data="data"></ClimaPonto>
            </template>
          </GoogleMap>
        </div>
      </template>
    </Layout>
  </div>
</template>
<script>
import Layout from "../components/layout/Tema.vue";
import GoogleMap from "../components/mapa/GoogleMap.vue";
import ClimaPonto from "../components/mapa/ClimaPonto.vue";
import Aside from "../components/mapa/Aside.vue";
import AsideClima from "../components/mapa/AsideClima.vue";
import AsideEstacaoSimples from "../components/mapa/AsideEstacaoSimples.vue";
import NewAside from "../components/mapa/NewAside.vue";
import NewAsideClimate from "../components/mapa/NewAsideClimate.vue";
import NewAsideDevice from "../components/mapa/NewAsideDevice.vue";
import NewAsideExternalDevice from "../components/mapa/NewAsideExternalDevice.vue";
import NewAsideDefesaCivil from "../components/mapa/NewAsideDefesaCivil.vue";
import NewAsideInmetAviso from "../components/mapa/NewAsideInmetAviso.vue";
import { DEFESA_CIVIL_GRANDEZAS } from "../mixin/onagro.js";
import Load from "../components/Load.vue";
import LogoIcon from "../components/LogoIcon.vue";
import PublicIcon from "../components/PublicIcon.vue";
import MapSearchBox from "../components/mapa/MapSearchBox.vue";
const StatusEnum = Object.freeze({
  Pendente: 1,
  Offline: 2,
  Online: 3,
});
// Preferência por usuário/navegador de agrupar os pins no modo Dispositivos. O acesso ao
// localStorage pode lançar (aba anônima, cookies bloqueados): nesse caso vale o padrão,
// que é NÃO agrupar (todos os pins visíveis).
const AGRUPAR_PINS_KEY = "onagro.mapa.agruparPins";
function lerPreferenciaAgrupar() {
  try {
    return localStorage.getItem(AGRUPAR_PINS_KEY) === "true";
  } catch (e) {
    return false;
  }
}
export default {
  components: {
    Layout,
    GoogleMap,
    Aside,
    AsideClima,
    AsideEstacaoSimples,
    NewAside,
    NewAsideClimate,
    NewAsideDevice,
    NewAsideExternalDevice,
    NewAsideDefesaCivil,
    NewAsideInmetAviso,
    Load,
    LogoIcon,
    PublicIcon,
    ClimaPonto,
    MapSearchBox,
  },
  data() {
    return {
      useNewAside: true,
      menuType: "estacao",
      agruparPins: lerPreferenciaAgrupar(),
      run: null,
      accept: false,
      pontos: null,
      loadMap: false,
      chart: {
        cpu1: null,
        cpu2: null,
      },
      climaBotoes: [
        {
          title: "Temperatura",
          icon: "fa fa-thermometer-full",
          value: "temperatura",
        },
        {
          title: "Precipitação",
          icon: "fa fa-cloud-showers-heavy",
          value: "precipitacao_prevista",
        },
        { title: "Vento", icon: "fa fa-wind", value: "vento_velocidade" },
        { title: "Umidade", icon: "fa fa-tint", value: "umidade" },
      ],
      estacaoBotoes: [
        {
          title: "Temperatura",
          icon: "fa fa-thermometer-full",
          value: "temperatura_media",
        },
        {
          title: "Precipitação",
          icon: "fa fa-cloud-showers-heavy",
          value: "precipitacao_soma",
        },
        { title: "Vento", icon: "fa fa-wind", value: "vento_velocidade_media" },
        { title: "Umidade", icon: "fa fa-tint", value: "umidade_media" },
      ],
      menuBotoes: [
        {
          title: "Dispositivos",
          eicon: true,
          value: "estacao",
          route: "/?map=estacao",
        },
        {
          title: "Previsão",
          icon: "fa fa-cloud-sun",
          value: "clima",
          route: "/?map=clima",
        },
        {
          // Estações públicas de terceiros (Defesa Civil / ANA / TideSat) monitoradas na AWS.
          title: "Público",
          picon: true,
          value: "publico",
          route: "/?map=publico",
        },
      ],
      info: {
        connection: "-",
        indicator: "-",
        chart: "-",
        table: "-",
        page: "-",
        panel: "-",
        filter: "-",
        user: "-",
      },
      osInfo: {
        memory: {},
        cpu: {},
      },
      values: [],
      selectedPoint: null,
      // Alterna o aside entre dispositivo próprio e de terceiros (v-if no slot do NewAside).
      selectedIsExternal: false,
      // Preenchido por /ExternalDevice/Availability; controla a aba "Público".
      temDispositivosExternos: false,
      // Camada da Defesa Civil (RS) dentro do modo "Público". Hoje só admin — quem decide
      // é o backend (/DefesaCivil/Availability), para a regra viver num lugar só.
      podeVerDefesaCivil: false,
      defesaCivilAtivo: false,
      defesaCivilGrandeza: "nivel",
      // Resolvido pelo webpack no build (o caminho vira hash), por isso em data() e não
      // interpolado direto no template.
      defesaCivilBrasao: require("../components/mapa/src/components/mapa/stationIcon/defesa-civil-rs.png"),
      // As duas camadas do modo Público são carregadas e guardadas separadamente: ligar ou
      // desligar a Defesa Civil só recompõe this.pontos, sem recarregar as públicas.
      pontosPublico: [],
      pontosDefesaCivil: [],
      // Alterna o painel lateral para o da estação da Defesa Civil.
      selectedIsDefesaCivil: false,
      // Camada de avisos do INMET dentro do modo "Público". Mesma regra de acesso da Defesa
      // Civil, decidida pelo backend (/Inmet/Availability).
      podeVerInmet: false,
      inmetAtivo: false,
      // Avisos são POLÍGONOS, não pontos: ficam fora de this.pontos e são desenhados por
      // GoogleMap.addPolygons, com ciclo de vida próprio.
      avisosInmet: [],
      inmetAtualizadoEm: null,
      // Dia mostrado no mapa ("yyyy-MM-dd"). Null só antes da primeira carga.
      inmetDiaSelecionado: null,
      // Último payload veio de uma coleta que falhou no backend: mostramos assim mesmo, com
      // aviso de que pode estar velho (some do mapa é pior do que velho num aviso de tempo).
      inmetDegradado: false,
      inmetCarregando: false,
      // Aviso aberto no painel lateral (clique no polígono).
      avisoInmetSelecionado: null,
      // Distingue "não tem acesso" de "ainda não sei" — sem isso o boot com ?map=publico
      // rebaixava o modo antes da resposta chegar.
      disponibilidadeExternaCarregada: false,
      climaType: "temperatura",
      estacaoType: "temperatura_media",
      climaAutoUpdate: null,
      estacaoAutoUpdate: null,
      publicoAutoUpdate: null,
      // Descarta respostas de trocas de modo anteriores (ver setPontos).
      pontosRequestId: 0,
      asideClimaKey: 0,
      sensorRotationIndex: 0,
      sensorRotationInterval: null,
      multiSensorMarkers: [],
    };
  },
  computed: {
    // A aba "Público" aparece quando o usuário tem ALGUMA das duas camadas: estações de
    // terceiros liberadas para ele, ou a rede da Defesa Civil. O critério é "a aba tem o
    // que mostrar" — antes bastava a primeira, porque era a única camada; hoje a Defesa
    // Civil sozinha já preenche o mapa, então exigir estação liberada esconderia a aba de
    // quem só tem acesso a ela.
    temAlgumaCamadaPublica() {
      return (
        this.temDispositivosExternos || this.podeVerDefesaCivil || this.podeVerInmet
      );
    },

    // Dias com avisos, na ordem do calendário — vira a fila de abas do card.
    //
    // Um aviso entra em TODOS os dias que cobre (o backend manda `dias` já resolvido), então
    // um alerta que atravessa a meia-noite aparece nas duas abas, que é onde ele de fato
    // está em vigor.
    inmetDias() {
      const porDia = {};

      this.avisosInmet.forEach((aviso) => {
        (aviso.dias || []).forEach((dia) => {
          if (!porDia[dia]) porDia[dia] = { dia, quantidade: 0, gravidadeMax: 0 };
          porDia[dia].quantidade++;
          // A aba mostra a cor do pior aviso do dia: é o que o usuário precisa ver antes de
          // decidir em qual dia clicar.
          porDia[dia].gravidadeMax = Math.max(
            porDia[dia].gravidadeMax,
            aviso.gravidade || 0
          );
        });
      });

      return Object.values(porDia).sort((a, b) => (a.dia < b.dia ? -1 : 1));
    },

    // Avisos do dia selecionado. É o que o mapa desenha e a legenda conta — mostrar todos os
    // dias de uma vez empilha polígonos de datas diferentes na mesma tela, sem como saber a
    // qual dia cada mancha pertence.
    avisosInmetDoDia() {
      if (!this.inmetDiaSelecionado) return this.avisosInmet;

      return this.avisosInmet.filter(
        (aviso) => (aviso.dias || []).indexOf(this.inmetDiaSelecionado) !== -1
      );
    },

    // Dentro do dia escolhido, separa o que já está valendo do que ainda vai começar.
    avisosInmetVigentes() {
      return this.avisosInmetDoDia.filter((aviso) => !aviso.futuro);
    },

    avisosInmetFuturos() {
      return this.avisosInmetDoDia.filter((aviso) => aviso.futuro);
    },

    inmetResumoSeveridades() {
      const porId = {};

      this.avisosInmetVigentes.forEach((aviso) => {
        const chave = aviso.idSeveridade;
        if (!porId[chave]) {
          porId[chave] = {
            id: chave,
            label: aviso.severidade || "Aviso",
            cor: aviso.cor,
            quantidade: 0,
          };
        }
        porId[chave].quantidade++;
      });

      // Mais grave primeiro: os ids do INMET são decrescentes em gravidade (4 = Grande
      // Perigo, 6 = Perigo Potencial), então ordenar por id crescente já resolve.
      return Object.values(porId).sort((a, b) => a.id - b.id);
    },

    menuBotoesVisiveis() {
      return this.menuBotoes.filter(
        (b) => b.value !== "publico" || this.temAlgumaCamadaPublica
      );
    },

    // Um botão por grandeza da Defesa Civil marcada com `mapa: true`. A lista mora no
    // mixin junto das unidades/cores, para o mapa e o painel lateral não divergirem.
    defesaCivilBotoes() {
      return Object.keys(DEFESA_CIVIL_GRANDEZAS)
        .filter((chave) => DEFESA_CIVIL_GRANDEZAS[chave].mapa)
        .map((chave) => ({
          value: chave,
          icon: DEFESA_CIVIL_GRANDEZAS[chave].icon,
          title: DEFESA_CIVIL_GRANDEZAS[chave].title || DEFESA_CIVIL_GRANDEZAS[chave].label,
        }));
    },
  },
  methods: {
    // A ROTA é a fonte única da verdade do modo do mapa; menuType é derivado dela pelo
    // watcher de $route.query.map. Antes o clique escrevia nos dois (menuType = x + push),
    // o que disparava setPontos duas vezes e gerava requisições concorrentes.
    trocarModo(botao) {
      if (this.menuType === botao.value) return; // já está nele: nada a fazer
      this.$router.push(botao.route);
    },

    // Decide se a aba "Público" existe para este usuário.
    //
    // Em caso de falha na chamada, o admin mantém a aba: ele sempre vê todas as estações,
    // então esconder por indisponibilidade momentânea (ou por rodar contra um backend mais
    // antigo, sem este endpoint) seria pior que mostrar. Para usuário comum o padrão
    // continua sendo esconder, já que sem liberação a aba abriria vazia.
    carregarDisponibilidadeExterna() {
      const isAdmin = this.userLevel(10);

      this.urlGet("/ExternalDevice/Availability")
        .then((res) => {
          this.temDispositivosExternos = !!(res.data && res.data.hasAccess);
        })
        .catch(() => {
          this.temDispositivosExternos = isAdmin;
        })
        .finally(() => {
          this.disponibilidadeExternaCarregada = true;

          // Chegou depois do watch da rota: se o usuário está em ?map=publico e não tem
          // acesso, volta para o mapa de dispositivos. Só navega — o watcher da rota
          // atualiza o menuType e dispara a recarga.
          //
          // Checa as DUAS camadas: quem só tem a Defesa Civil não pode ser expulso da aba
          // por não ter estação de terceiros liberada. Como as duas chamadas de
          // disponibilidade correm em paralelo, o redirect também é reavaliado quando a da
          // Defesa Civil responde (ver carregarDisponibilidadeDefesaCivil).
          this.redirecionarSeSemCamadaPublica();
        });
    },

    // Sai de ?map=publico só quando NENHUMA das camadas está disponível. Chamado pelas duas
    // consultas de disponibilidade, que correm em paralelo: a que responder por último dá a
    // palavra final, e assim quem tem apenas uma das camadas não é expulso pela outra.
    redirecionarSeSemCamadaPublica() {
      if (!this.temAlgumaCamadaPublica && this.$route.query.map === "publico") {
        this.$router.push("/?map=estacao");
      }
    },

    // Decide se a camada da Defesa Civil aparece no modo "Público".
    //
    // A regra de acesso (admin ou usuário com a flag de estações de terceiros) fica no
    // backend, em /DefesaCivil/Availability — o front só pergunta "posso?". Em caso de
    // falha esconde o botão: a camada é um extra, e um botão que abre um mapa vazio é pior
    // que um botão ausente.
    carregarDisponibilidadeDefesaCivil() {
      this.urlGet("/DefesaCivil/Availability")
        .then((res) => {
          this.podeVerDefesaCivil = !!(res.data && res.data.hasAccess);
        })
        .catch(() => {
          this.podeVerDefesaCivil = false;
        })
        .finally(() => {
          // Sem acesso, a camada não pode ficar ligada por um estado antigo.
          if (!this.podeVerDefesaCivil) this.defesaCivilAtivo = false;

          // Esta resposta pode ser a que libera a aba "Público" (usuário sem estação de
          // terceiros liberada, mas com acesso à Defesa Civil).
          this.redirecionarSeSemCamadaPublica();
        });
    },

    // Decide se a camada de avisos do INMET aparece no modo "Público". Mesma lógica da
    // Defesa Civil: a regra vive no backend e o front só pergunta "posso?".
    carregarDisponibilidadeInmet() {
      this.urlGet("/Inmet/Availability")
        .then((res) => {
          this.podeVerInmet = !!(res.data && res.data.hasAccess);
        })
        .catch(() => {
          this.podeVerInmet = false;
        })
        .finally(() => {
          if (!this.podeVerInmet) this.inmetAtivo = false;
          this.redirecionarSeSemCamadaPublica();
        });
    },

    // Busca os avisos do INMET e desenha os polígonos.
    //
    // Chamar isto NÃO gera tráfego para o INMET: o backend serve de um cache alimentado por
    // um coletor em intervalo fixo (ver InmetAvisosBackgroundService). Por isso não há aqui
    // o cuidado de "não recarregar" que a camada da Defesa Civil tem — o custo é uma leitura
    // de memória no servidor, e a resposta ainda é revalidada por ETag.
    carregarInmet() {
      if (!this.podeVerInmet || !this.inmetAtivo) return Promise.resolve();

      this.inmetCarregando = true;

      return this.getInmetAvisos()
        .then((e) => {
          this.avisosInmet = (e && e.avisos) || [];
          this.inmetAtualizadoEm = (e && e.atualizadoEm) || null;
          this.inmetDegradado = !!(e && e.degradado);
          this.escolherDiaInmet();
          this.revincularAvisoSelecionado();
        })
        .catch((err) => {
          console.error("Erro ao carregar avisos do INMET:", err);
          this.avisosInmet = [];
          this.inmetDegradado = false;
        })
        .finally(() => {
          this.inmetCarregando = false;
          this.desenharAvisosInmet();
        });
    },

    // Redesenha os polígonos da camada do INMET (ou os apaga, se estiver desligada).
    //
    // Os polígonos vivem FORA do this.pontos e do markerGroup: addPoints só limpa markers,
    // então esta camada tem o seu próprio ciclo de limpeza em GoogleMap.clearPolygons.
    desenharAvisosInmet() {
      const mapa = this.$refs.map;
      if (!mapa || !mapa.addPolygons) return;

      if (!this.inmetAtivo || !this.podeVerInmet || this.menuType !== "publico") {
        mapa.clearPolygons();
        return;
      }

      mapa.addPolygons(
        this.avisosInmetDoDia.map((aviso) => ({
          id: aviso.id,
          geometria: aviso.geometria,
          cor: aviso.cor,
          // Avisos que ainda não começaram vêm marcados pelo backend e são desenhados só
          // com o contorno: o polígono de um aviso de depois de amanhã é idêntico ao de um
          // vigente, e preenchê-los igual faria uma previsão parecer um evento em curso.
          // Gravidade menor também os manda para baixo no empilhamento.
          futuro: aviso.futuro === true,
          gravidade: aviso.futuro ? -1 : aviso.gravidade,
          // Pictograma do fenômeno, desenhado no centro da área. A cor diz a gravidade; o
          // ícone diz O QUE é — duas manchas amarelas podem ser tempestade e baixa umidade.
          icone: aviso.pictograma || null,
          titulo:
            aviso.descricao +
            " · " +
            aviso.severidade +
            (aviso.futuro ? " · a partir de " + aviso.inicio : ""),
          dados: aviso,
        })),
        (aviso) => this.abrirAvisoInmet(aviso)
      );
    },

    // Abre o painel lateral com o detalhe do aviso clicado.
    abrirAvisoInmet(aviso) {
      this.avisoInmetSelecionado = aviso;

      // Estes flags trocam o componente do slot do NewAside; o aviso não é um ponto, então
      // limpamos a seleção de ponto para não deixar um pin marcado como selecionado.
      this.selectedIsDefesaCivil = false;
      this.selectedIsExternal = false;
      this.selectedPoint = null;

      if (!this.$refs.aside) return;

      // Cabeçalho genérico: o nome do fenômeno é o título DENTRO do painel, não aqui.
      // Repetido nos dois lugares, ocupa duas linhas dizendo a mesma coisa.
      this.$refs.aside.footerButton = null;
      this.$refs.aside.fadeIn(["Aviso meteorológico", ""]);
    },

    // Escolhe qual dia o mapa mostra depois de uma carga.
    //
    // Preserva a escolha do usuário se aquele dia ainda existir — sem isso, o refresh de 5
    // min jogaria a tela de volta para hoje enquanto ele estivesse olhando amanhã.
    escolherDiaInmet() {
      const dias = this.inmetDias.map((d) => d.dia);

      if (!dias.length) {
        this.inmetDiaSelecionado = null;
        return;
      }

      if (dias.indexOf(this.inmetDiaSelecionado) !== -1) return;

      // Abre no dia de hoje; se hoje não tiver aviso, cai no primeiro dia que tiver, para a
      // camada não abrir vazia tendo o que mostrar logo adiante.
      const hoje = this.dataLocalIso(new Date());
      this.inmetDiaSelecionado = dias.indexOf(hoje) !== -1 ? hoje : dias[0];
    },

    // Troca o dia mostrado no mapa.
    selecionarDiaInmet(dia) {
      if (this.inmetDiaSelecionado === dia) return;

      this.inmetDiaSelecionado = dia;
      // O aviso aberto pode não existir no novo dia: fecha antes de redesenhar para o painel
      // nunca descrever um alerta que não está mais na tela.
      this.fecharAvisoInmet();
      this.desenharAvisosInmet();
    },

    // Data no formato "yyyy-MM-dd" pelo fuso LOCAL.
    //
    // toISOString() daria o dia em UTC, e no Brasil (UTC-3) isso vira o dia seguinte a partir
    // das 21h — a aba "hoje" deixaria de casar com o dia real do usuário à noite.
    dataLocalIso(data) {
      const mes = String(data.getMonth() + 1).padStart(2, "0");
      const dia = String(data.getDate()).padStart(2, "0");
      return data.getFullYear() + "-" + mes + "-" + dia;
    },

    // Rótulo curto da aba: "Hoje", "Amanhã" ou "Seg 8".
    //
    // Curto de propósito: as abas dividem a largura do card, então um rótulo longo
    // ("Segunda-feira, 8") empurraria as outras ou reintroduziria a rolagem.
    rotuloDiaInmet(dia) {
      const hoje = new Date();
      if (dia === this.dataLocalIso(hoje)) return "Hoje";

      const amanha = new Date(hoje);
      amanha.setDate(amanha.getDate() + 1);
      if (dia === this.dataLocalIso(amanha)) return "Amanhã";

      // Monta a data com componentes locais: new Date("2026-09-08") seria interpretado como
      // UTC e voltaria um dia no fuso do Brasil.
      const partes = dia.split("-");
      const data = new Date(partes[0], partes[1] - 1, partes[2]);

      const semana = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];
      return semana[data.getDay()] + " " + data.getDate();
    },

    // Data por extenso para o tooltip da aba — o rótulo é abreviado por espaço, então a
    // data completa precisa estar em algum lugar.
    tituloDiaInmet(d) {
      const partes = d.dia.split("-");
      return (
        d.quantidade +
        " aviso(s) em " +
        partes[2] + "/" + partes[1] + "/" + partes[0]
      );
    },

    // Reaponta o painel para a versão nova do aviso após um refresh.
    //
    // Os objetos de `avisosInmet` são recriados a cada carga, então a referência guardada em
    // `avisoInmetSelecionado` fica órfã: o painel continuaria mostrando o conteúdo antigo
    // (vigência, riscos) mesmo depois de o aviso ser reemitido — ou já removido do mapa.
    revincularAvisoSelecionado() {
      if (!this.avisoInmetSelecionado) return;

      const atual = this.avisosInmet.find(
        (aviso) => aviso.idAviso === this.avisoInmetSelecionado.idAviso
      );

      // Encerrado ou vencido: o polígono já sumiu do mapa, então o painel também sai.
      if (!atual) {
        this.fecharAvisoInmet();
        return;
      }

      this.avisoInmetSelecionado = atual;
    },

    // Hora da última coleta do backend, no fuso do usuário. O backend manda UTC, então a
    // conversão é do navegador mesmo — é a hora local que responde "isso é recente?".
    formatarHoraInmet(iso) {
      if (!iso) return "";

      const data = new Date(iso);
      if (isNaN(data.getTime())) return "";

      return data.toLocaleTimeString("pt-BR", {
        hour: "2-digit",
        minute: "2-digit",
      });
    },

    // Fecha o painel do aviso, se for ele que está aberto. Checa antes de mexer no aside
    // para não fechar o painel de uma estação que o usuário tenha aberto depois.
    fecharAvisoInmet() {
      if (!this.avisoInmetSelecionado) return;

      this.avisoInmetSelecionado = null;
      // Apaga o destaque no mapa junto com o painel: um contorno realcado sem painel aberto
      // sugere uma selecao que nao existe mais.
      if (this.$refs.map && this.$refs.map.setPolygonSelecionado) {
        this.$refs.map.setPolygonSelecionado(null);
      }
      if (this.$refs.aside) this.$refs.aside.show = false;
    },

    // Recompõe os pontos do modo "Público" a partir das duas camadas já carregadas.
    // As estações da Defesa Civil SOMAM às públicas — não substituem: são redes
    // diferentes e ver as duas ao mesmo tempo é justamente o objetivo.
    aplicarPontosPublico() {
      const publicos = this.pontosPublico || [];
      const defesaCivil = this.defesaCivilAtivo ? this.pontosDefesaCivil || [] : [];
      this.pontos = publicos.concat(defesaCivil);

      try {
        this.updatePontos();
      } catch (err) {
        console.error("Erro ao desenhar pontos no mapa:", err);
      }
    },

    // Carrega (ou recarrega) só a camada da Defesa Civil, mantendo as públicas na tela.
    carregarDefesaCivil() {
      if (!this.podeVerDefesaCivil || !this.defesaCivilAtivo) return Promise.resolve();

      return this.getDefesaCivilPontos()
        .then((e) => {
          this.pontosDefesaCivil = (e && e.data) || [];
        })
        .catch((err) => {
          console.error("Erro ao carregar estações da Defesa Civil:", err);
          this.pontosDefesaCivil = [];
        })
        .finally(() => {
          if (this.menuType === "publico") this.aplicarPontosPublico();
        });
    },

    // Valor da grandeza selecionada, já formatado em pt-BR. Devolve null quando a estação
    // não reporta aquela grandeza — o pin então mostra "--" em cinza.
    getDefesaCivilValor(point, grandeza = this.defesaCivilGrandeza) {
      const meta = DEFESA_CIVIL_GRANDEZAS[grandeza];
      const bruto = point.valores ? point.valores[grandeza] : null;
      if (bruto == null || meta == null) return null;

      const n = Number(bruto);
      if (isNaN(n)) return null;

      return n.toLocaleString("pt-BR", {
        minimumFractionDigits: meta.casas,
        maximumFractionDigits: meta.casas,
      });
    },

    // Tendência do nível do rio. A origem manda uma TAXA (variação por hora), não um
    // rótulo: perto de zero é ruído de sensor, então há uma zona morta antes de chamar
    // de "subindo"/"descendo".
    getDefesaCivilTendencia(point) {
      const taxa = point.valores ? point.valores.nivel_tendencia : null;
      if (taxa == null) return null;

      const n = Number(taxa);
      if (isNaN(n)) return null;
      if (n > 0.01) return "subindo";
      if (n < -0.01) return "descendo";
      return "estavel";
    },

    // Setas idênticas às do pin de terceiros (getExternalTrendSvg) — o mesmo dado não pode
    // ter dois desenhos diferentes conforme a camada.
    getDefesaCivilTendenciaSvg(tipo) {
      const wrap = (inner) =>
        '<svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" ' +
        'stroke-width="3" stroke-linecap="round" stroke-linejoin="round">' + inner + "</svg>";

      switch (tipo) {
        case "subindo": return wrap('<path d="M7 17L17 7"/><path d="M9 7h8v8"/>');
        case "descendo": return wrap('<path d="M7 7l10 10"/><path d="M17 9v8H9"/>');
        case "estavel": return wrap('<path d="M6 12h12"/>');
        default: return "";
      }
    },

    // Escudo no badge do pin: identifica a fonte de relance e separa visualmente esta
    // camada dos pins de terceiros (que têm o badge à direita, com a seta de tendência).
    // Path fixo no código — nada aqui vem da API.
    getDefesaCivilEscudoSvg() {
      return (
        '<svg viewBox="0 0 24 24" width="13" height="13" fill="#fff" aria-hidden="true">' +
        '<path d="M12 2 4 5.5v5.9c0 4.6 3.2 8.9 8 10.6 4.8-1.7 8-6 8-10.6V5.5L12 2z"/>' +
        "</svg>"
      );
    },

    // O nome da estação vem de uma API de terceiros e é injetado como atributo title do
    // pin — escapar aspas e sinais evita que um nome com caractere especial quebre o HTML
    // do marker (ou injete markup).
    escaparAtributo(texto) {
      return String(texto == null ? "" : texto)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    },

    // Pin da camada da Defesa Civil: cápsula com escudo à esquerda e o valor da grandeza
    // selecionada à direita. Cinza quando a estação está muda (offline calculado no
    // servidor) — o número exibido ali é velho e não pode parecer atual.
    addDefesaCivilPin(point, map) {
      const meta = DEFESA_CIVIL_GRANDEZAS[this.defesaCivilGrandeza] || {};
      const isSelected = this.selectedPoint && this.selectedPoint.id === point.id;
      const valor = this.getDefesaCivilValor(point);
      const cor = point.offline || valor == null ? "#9e9e9e" : meta.color || "#006035";
      const texto = valor == null ? "--" : valor + (meta.unit ? " " + meta.unit : "");

      // Seta de tendência só no nível do rio: é a única grandeza para a qual a origem
      // informa variação, e é onde "está subindo" muda a leitura do número.
      const tendencia =
        this.defesaCivilGrandeza === "nivel" && !point.offline
          ? this.getDefesaCivilTendencia(point)
          : null;
      const setaHtml = tendencia
        ? '<span class="dc-pin-trend">' + this.getDefesaCivilTendenciaSvg(tendencia) + "</span>"
        : "";

      const titulo =
        point.nome +
        " (" + point.codigo + ")" +
        " · " + (meta.label || this.defesaCivilGrandeza) + ": " + texto +
        (point.offline ? " · sem transmitir" : "");

      const htmlIcon =
        '<div class="dc-pin' + (isSelected ? " is-selected" : "") +
        (point.offline ? " is-offline" : "") + '" title="' + this.escaparAtributo(titulo) + '">' +
        '  <div class="dc-pin-capsule">' +
        '    <span class="dc-pin-badge" style="background:' + cor + ';">' +
        this.getDefesaCivilEscudoSvg() +
        "    </span>" +
        '    <span class="dc-pin-value">' + this.escaparAtributo(texto) + setaHtml + "</span>" +
        "  </div>" +
        '  <div class="dc-pin-stem" style="background:' + cor + ';"></div>' +
        "</div>";

      const marker = map.addMarkerWithDivIcon(point.latitude, point.longitude, htmlIcon);
      if (!marker) return;

      marker.addClickListener(() => {
        this.clickClima({
          latlng: { lat: point.latitude, lng: point.longitude },
          target: {
            options: { point: point, icon: { options: { html: htmlIcon } } },
            getIcon: () => ({ options: { html: htmlIcon } }),
            setIcon: () => {},
          },
        });
      });
    },

    // Retorna a URL do ícone que REPRESENTA o tipo de sensor (não o tipo de dado).
    // Um arquivo por tipo de sensor — ajustar os nomes conforme indicado.
    // Os SVGs da pasta stationIcon têm fill claro (#F9F9F9/branco), feitos para
    // sentar sobre o fundo colorido do pin.
    getSensorIconUrl(sensorType) {
      // require() precisa de caminho LITERAL (sem variável) para o webpack
      // resolver o asset corretamente. Os SVGs podem ser pretos: a cor é
      // aplicada na renderização (mask) — ver maskIconHtml.
      const estacaoIcon = require("../components/mapa/src/components/mapa/stationIcon/Estacao.svg");
      const soloIcon = require("../components/mapa/src/components/mapa/stationIcon/Sensor Solo.svg");
      const folharIcon = require("../components/mapa/src/components/mapa/stationIcon/Sensor Folhar.svg");
      const ambienteIcon = require("../components/mapa/src/components/mapa/stationIcon/Ambiente.svg");
      const lutIcon = require("../components/mapa/src/components/mapa/stationIcon/lut-and-fotobio.svg");
      const sondaHidroNivel = require("../components/mapa/src/components/mapa/stationIcon/Sonda-hidro-and-nivel.svg");
      const sondaLaser = require("../components/mapa/src/components/mapa/stationIcon/Sonda-Laser.svg");
      const ritterIcon = require("../components/mapa/src/components/mapa/stationIcon/Ritter.svg");
      const iconByType = {
        ritter: ritterIcon,
        fotobio: lutIcon,
        estacao: estacaoIcon,
        solo: soloIcon,
        ambiente: ambienteIcon,
        folhar: folharIcon,
        lut: lutIcon,
        "sonda-hidrostatica": sondaHidroNivel,
        "sonda-nivel": sondaHidroNivel,
        "sonda-caixa": sondaHidroNivel,
        "sonda-laser": sondaLaser,
        sonda: sondaHidroNivel,
      };
      const type = (sensorType || "").toLowerCase();
      return iconByType[type] || estacaoIcon;
    },
    // Gera o HTML (string) de um ícone monocromático pintado por `color`, usando
    // o SVG como máscara CSS. Mesma técnica do componente reutilizável MaskIcon,
    // mas em string (o pin é montado como HTML string para o overlay do mapa).
    maskIconHtml(src, color, size, extraClass) {
      const px = (size || 20) + "px";
      const url = "url('" + src + "')";
      const style =
        "width:" + px + ";height:" + px + ";display:inline-block;flex:0 0 auto;" +
        "background-color:" + color + ";" +
        "-webkit-mask:" + url + " center / contain no-repeat;" +
        "mask:" + url + " center / contain no-repeat;";
      return '<span class="' + (extraClass || "") + '" style="' + style + '"></span>';
    },
    // Nome legível do tipo de sensor.
    getSensorTypeName(sensorType) {
      const names = {
        estacao: "Estação",
        solo: "Solo",
        ambiente: "Ambiente",
        folhar: "Folha",
        lut: "LUT",
        ritter: "Ritter",
        fotobio: "Fotobio",
        "sonda-hidrostatica": "Sonda Hidrostática",
        "sonda-laser": "Sonda Laser",
        "sonda-nivel": "Sonda Nível",
        "sonda-caixa": "Caixa d'Água",
        sonda: "Sonda",
      };
      const type = (sensorType || "").toLowerCase();
      return names[type] || (sensorType || "");
    },
    getBatteryType(batteryLevel) {
      const level = parseFloat(batteryLevel);
      if (level >= 2.8 && level <= 4.2) {
        return 'low_voltage'; // Se entre 2.8V e 4.2V, é bateria tipo 1 (baixa voltagem)
      }
      else if (level >= 8.2 && level <= 12.6) {
        return 'high_voltage'; // Se entre 8.2V e 12.6V, é bateria tipo 2 (alta voltagem)
      }
      else if (level < 6.0) { // Se não se encaixa nos ranges, assume o tipo baseado no valor
        return 'low_voltage';
      } else {
        return 'high_voltage';
      }
    },
    isBatteryLow(batteryLevel) {
      const level = parseFloat(batteryLevel);
      const batteryType = this.getBatteryType(batteryLevel);
      
      if (batteryType === 'low_voltage') {
        // Para bateria 2.8V-4.2V, considera baixa quando menor que 3.2V
        return level < 3.2;
      } else {
        // Para bateria 8.2V-12.6V, considera baixa quando menor que 10.0V
        return level < 10.0;
      }
    },
    // Conteúdo interno do pin para um frame da rotação.
    // A rotação alterna, por sensor: frame par = ícone do tipo, frame ímpar = valor.
    getSensorPinContent(point, frame, dark = false) {
      const sensors = point.sensors;
      if (!sensors || sensors.length === 0) return "";
      const sensorIndex = Math.floor(frame / 2) % sensors.length;
      const showIcon = frame % 2 === 0;
      const sensor = sensors[sensorIndex];
      // Sensor com rótulo (tanques do Fotobio: T1, T2...): o rótulo entra no lugar do
      // ícone, para anunciar de qual tanque é a temperatura do frame seguinte.
      if (showIcon && sensor.label) {
        const labelColor = dark ? "color: #333333;" : "";
        return '<span class="square-pin-icon-text pin-content-anim" style="' + labelColor + '">' + sensor.label + "</span>";
      }
      if (showIcon) {
        const iconUrl = this.getSensorIconUrl(sensor.sensorType);
        // Ícone branco no pin colorido; escuro no pin público (fundo branco).
        const iconColor = dark ? "#333333" : "#ffffff";
        return this.maskIconHtml(iconUrl, iconColor, 18, "square-pin-icon-img pin-content-anim");
      }
      const text = this.formatPinValue(sensor.value) + sensor.unit;
      // Miolo do pin tem 38px: texto longo ("-10,5°", "1234L") reduz a fonte para não cortar.
      const fontSize = text.length >= 7 ? "font-size: 10px;" : text.length >= 6 ? "font-size: 11px;" : "";
      const color = dark ? "color: #333333;" : "";
      return '<span class="square-pin-icon-text pin-content-anim" data-pin-qr="' + point.qrcodeid + '" style="' + color + fontSize + '">' + text + "</span>";
    },
    // Conteúdo do card expandido (hover/long-press): badge colorido com o ícone
    // do sensor atual + nome da estação + valor (texto escuro sobre branco).
    // Acompanha a rotação dos sensores. `badgeBg` é o style de fundo do badge.
    // Valor do pin: 1 casa decimal (12 escondia 11,76); de 100 para cima fica inteiro,
    // senão não cabe no pin (ex.: volume do Ritter em L). Vírgula, como os pins externos.
    formatPinValue(value) {
      const n = parseFloat(value);
      if (isNaN(n)) return "--";
      return n.toFixed(Math.abs(n) >= 100 ? 0 : 1).replace(".", ",");
    },
    getSensorExpandedContent(point, frame, badgeBg) {
      const sensors = point.sensors;
      if (!sensors || sensors.length === 0) {
        return '<span class="pin-expanded-name">' + (point.nome || "") + "</span>";
      }
      const sensorIndex = Math.floor(frame / 2) % sensors.length;
      const sensor = sensors[sensorIndex];
      const iconUrl = this.getSensorIconUrl(sensor.sensorType);
      // Nome = tipo do sensor que está sendo apresentado (não o nome do dispositivo).
      const name = this.getSensorTypeName(sensor.sensorType) + (sensor.label ? " " + sensor.label : "");
      const value = this.formatPinValue(sensor.value) + sensor.unit;
      // Ícone escuro se o badge for branco (público); branco caso contrário.
      const isWhiteBadge = (badgeBg || "").indexOf("#ffffff") !== -1;
      const iconColor = isWhiteBadge ? "#333333" : "#ffffff";
      return (
        '<div class="pin-expanded-badge" style="' + (badgeBg || "") + '">' +
        this.maskIconHtml(iconUrl, iconColor, 26, "pin-expanded-icon") +
        "</div>" +
        '<div class="pin-expanded-info">' +
        '<span class="pin-expanded-name">' + name + "</span>" +
        '<span class="pin-expanded-value">' + value + "</span>" +
        "</div>"
      );
    },
    updatePinTexts() {
      if (this.menuType !== "estacao") return;
      this.multiSensorMarkers.forEach(({ marker, point }) => {
        if (!marker.div || !point.sensors || point.sensors.length === 0) return;
        const isPublicOnly = point.publico && !point.acessoCompleto;
        const bgStyle = this.getStationPinBgStyle(point, this.sensorRotationIndex);
        const slot = marker.div.querySelector('.square-pin-icon-text-container');
        if (slot) {
          // Atualiza cor de fundo (escala do sensor exibido) + conteúdo.
          slot.setAttribute('style', bgStyle);
          slot.innerHTML = this.getSensorPinContent(point, this.sensorRotationIndex, isPublicOnly);
        }
        const expanded = marker.div.querySelector('.pin-expanded-body');
        if (expanded) {
          // O card expandido mostra ícone+valor do mesmo sensor — esse índice só
          // muda a cada 2 frames (ícone/valor). Só atualiza/anima quando o SENSOR
          // de fato muda (evita 2 animações idênticas por sensor).
          const sensorIndex = Math.floor(this.sensorRotationIndex / 2) % point.sensors.length;
          if (marker._expandedSensorIndex !== sensorIndex) {
            marker._expandedSensorIndex = sensorIndex;
            expanded.innerHTML = this.getSensorExpandedContent(point, this.sensorRotationIndex, bgStyle);
            // Anima o conteúdo do card como um bloco só.
            expanded.classList.remove('pin-content-anim');
            void expanded.offsetWidth; // força reflow para reiniciar a animação
            expanded.classList.add('pin-content-anim');
          }
        }
      });
    },
    getBatteryPercentage(batteryLevel) {
      const level = parseFloat(batteryLevel);
      const batteryType = this.getBatteryType(batteryLevel);
      let percentage = 0;
      if (batteryType === 'low_voltage') {
        const minVoltage = 2.8;
        const maxVoltage = 4.2;
        percentage = ((level - minVoltage) / (maxVoltage - minVoltage)) * 100;
      } else {
        const minVoltage = 8.2;
        const maxVoltage = 12.6;
        percentage = ((level - minVoltage) / (maxVoltage - minVoltage)) * 100;
      }
      return Math.max(0, Math.min(100, percentage));
    },
    getBatteryColor(batteryLevel) {
      const percentage = this.getBatteryPercentage(batteryLevel);
      if (percentage >= 60) {
        return '#4CAF50'; // Verde - bateria alta
      } else if (percentage >= 30) {
        return '#FF9800'; // Laranja - bateria média
      } else {
        return '#F44336'; // Vermelho - bateria baixa
      }
    },
    // Converte hex para RGB
    hexToRgb(hex) {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : { r: 0, g: 0, b: 0 };
    },
    // Interpola entre duas cores baseado em um percentual (0-1)
    interpolateColor(color1, color2, factor) {
      const c1 = this.hexToRgb(color1);
      const c2 = this.hexToRgb(color2);
      return {
        r: Math.round(c1.r + (c2.r - c1.r) * factor),
        g: Math.round(c1.g + (c2.g - c1.g) * factor),
        b: Math.round(c1.b + (c2.b - c1.b) * factor)
      };
    },
    // Obtém cor do gradiente baseado no valor e escala
    getGradientColor(value, scale) {
      // scale é um array de { value, color } ordenado por value
      if (value <= scale[0].value) {
        return this.hexToRgb(scale[0].color);
      }
      if (value >= scale[scale.length - 1].value) {
        return this.hexToRgb(scale[scale.length - 1].color);
      }

      // Encontra os dois pontos entre os quais o valor está
      for (let i = 0; i < scale.length - 1; i++) {
        if (value >= scale[i].value && value <= scale[i + 1].value) {
          const range = scale[i + 1].value - scale[i].value;
          const factor = (value - scale[i].value) / range;
          return this.interpolateColor(scale[i].color, scale[i + 1].color, factor);
        }
      }
      return this.hexToRgb(scale[0].color);
    },
    // Escalas de cores para cada tipo de dado do clima
    getClimaColorScale(type) {
      const scales = {
        // Temperatura: roxo -> azul -> ciano -> verde -> amarelo -> laranja -> vermelho
        temperatura: [
          { value: -20, color: '#9B59B6' },
          { value: -10, color: '#5B6CC9' },
          { value: 0, color: '#00D4FF' },
          { value: 10, color: '#2ECC71' },
          { value: 20, color: '#F1C40F' },
          { value: 30, color: '#E67E22' },
          { value: 40, color: '#C0392B' }
        ],
        // Precipitação: azul forte -> azul -> ciano -> verde -> amarelo -> laranja -> vermelho
        precipitacao_prevista: [
          { value: 0, color: '#1A237E' },
          { value: 0.4, color: '#1A237E' },
          { value: 2, color: '#3498DB' },
          { value: 3, color: '#1ABC9C' },
          { value: 6, color: '#F1C40F' },
          { value: 9.6, color: '#E74C3C' },
          { value: 12, color: '#C0392B' }
        ],
        // Vento: cinza -> azul claro -> ciano -> verde -> amarelo -> laranja -> rosa
        vento_velocidade: [
          { value: 0, color: '#BDC3C7' },
          { value: 10, color: '#5DADE2' },
          { value: 20, color: '#48C9B0' },
          { value: 35, color: '#27AE60' },
          { value: 55, color: '#F4D03F' },
          { value: 70, color: '#EB984E' },
          { value: 100, color: '#AF7AC5' }
        ],
        // Umidade: verde -> ciano -> azul claro -> azul escuro
        umidade: [
          { value: 0, color: '#7ABC28' },
          { value: 30, color: '#7ABC28' },
          { value: 50, color: '#3898AE' },
          { value: 80, color: '#3898AE' },
          { value: 90, color: '#223879' },
          { value: 100, color: '#223879' }
        ],
        // Nível/sonda (metros): azul claro -> azul -> azul escuro.
        // Escala provisória; ajustável quando o usuário passar a definitiva.
        nivel: [
          { value: 0, color: '#7FD4F0' },
          { value: 2, color: '#36A9E1' },
          { value: 5, color: '#1B6CA8' },
          { value: 10, color: '#0A3D62' }
        ]
      };
      return scales[type] || scales.temperatura;
    },
    // Cor (objeto rgb) para um sensor da rotação, conforme seu tipo/unidade.
    getSensorColor(sensor) {
      if (!sensor) return { r: 75, g: 180, b: 21 };
      const type = (sensor.sensorType || "").toLowerCase();
      const valor = parseFloat(sensor.value);
      if (type.startsWith("sonda") || sensor.unit === "m") {
        return this.getGradientColor(valor, this.getClimaColorScale("nivel"));
      }
      // Ritter é volume (L), não temperatura: a escala de temperatura pintaria um
      // volume alto de vermelho. Fica com o verde padrão.
      if (type === "ritter") return { r: 75, g: 180, b: 21 };
      // Demais sensores de estação são temperatura (unidade °).
      return this.getGradientColor(valor, this.getClimaColorScale("temperatura"));
    },
    // Sensor atualmente exibido pela rotação (mesma indexação do conteúdo do pin).
    getCurrentSensor(point, frame) {
      const sensors = point.sensors;
      if (!sensors || sensors.length === 0) return null;
      return sensors[Math.floor(frame / 2) % sensors.length];
    },
    // Estilo de fundo do pin de estação para o frame atual:
    // público=branco, offline=cinza (verde se selecionado), online=escala do
    // sensor exibido, selecionado=verde #006035.
    getStationPinBgStyle(point, frame) {
      const isPublicOnly = point.publico && !point.acessoCompleto;
      const isOffline = point.status !== StatusEnum.Online;
      const isSelected =
        this.selectedPoint && point.id == this.selectedPoint.id && point.qrcodeid !== 1;
      if (isPublicOnly) return "background-color: #E8F8E6;"; // verde claro
      if (isSelected) return "background-color: rgb(0,96,53);"; // #006035
      if (isOffline) return "background-color: #c7c7c7;";
      const c = this.getSensorColor(this.getCurrentSensor(point, frame));
      return "background-color: rgb(" + c.r + "," + c.g + "," + c.b + ");";
    },
    changeMap(type) {
      // Só navega: menuType é derivado da rota pelo watcher de $route.query.map.
      if (this.menuType === type) return;
      this.$router.push({ path: "/", query: { map: type } });
    },
    asideClose() {
      this.selectedPoint = null;
      this.selectedIsExternal = false;
      this.selectedIsDefesaCivil = false;
      // Sem isto o aviso continuaria montado no slot e reapareceria no próximo clique em
      // qualquer pin, já que o v-else-if dele vem antes dos demais.
      this.avisoInmetSelecionado = null;
      if (this.$refs.map && this.$refs.map.setPolygonSelecionado) {
        this.$refs.map.setPolygonSelecionado(null);
      }
    },
    showAside() {
      this.updatePontos();
    },
    clickPonto() {},

    updatePontos() {
      this.multiSensorMarkers = [];
      if (!this.$refs.map) return;
      this.move(this.$refs.map, this.$refs.map.getInfo());
    },
    getType(type = this.menuType) {
      if (type == "clima") {
        return this.climaType;
      } else {
        return this.estacaoType;
      }
    },
    selectedColor() {
      if (this.menuType == "clima") {
        if (
          this.climaType == "precipitacao_prevista" ||
          this.climaType == "umidade"
        ) {
          return "rgb(255,0,0)";
        } else {
          return "rgb(0,0,255)";
        }
      } else {
        if (
          this.estacaoType == "precipitacao_soma" ||
          this.estacaoType == "umidade_media"
        ) {
          return "rgb(255,0,0)";
        } else {
          return "rgb(0,0,255)";
        }
      }
    },
    move(map, info) {
      // getInfo() devolve null enquanto o Google Maps não tem bounds — situação normal no
      // boot, quando os pontos chegam antes de o mapa terminar de inicializar. Sem esta
      // guarda, getPontosFiltrado lia info.latitude_min e estourava TypeError dentro do
      // .then() de setPontos; o .catch() engolia o erro e zerava this.pontos, deixando o
      // mapa vazio até a próxima interação. O listener 'idle' rechama move() assim que os
      // bounds existem, então apenas ignorar aqui é suficiente.
      if (!info) return;

      if (this.pontos) {
        // No modo Público a intenção é enxergar todas as estações de uma vez (são poucas
        // e o valor está justamente em comparar rios vizinhos), então não há teto de
        // pontos nem agrupamento. Nos outros modos o limite evita renderizar centenas de
        // pins num zoom aberto.
        const ehPublico = this.menuType === "publico";

        var points = map.getPontosFiltrado(
          this.pontos,
          info,
          ehPublico ? null : 30,
          this.selectedPoint
        );

        // Cluster só no modo dispositivos: no clima os pontos são por cidade e não se
        // sobrepõem; no público o agrupamento esconderia justamente o que se quer ver.
        // Mesmo em dispositivos o usuário pode desligar pelo botão do mapa.
        this.$refs.map.addPoints(
          points,
          this.selectedPoint,
          this.menuType === "estacao" && this.agruparPins
        );
      }
    },
    rebuildAsideClima() {
      this.asideClimaKey = (this.asideClimaKey || 0) + 1;
    },
    clickClima(data) {
      this.$refs.map.move(
        data.latlng.lat,
        data.latlng.lng,
        this.$refs.map.getZoom()
      );

      if (this.menuType === "clima" && this.$refs.aside_clima && this.$refs.aside_clima.grafico) {
        this.$refs.aside_clima.grafico.destroy();
        this.$refs.aside_clima.grafico = null;
      }

      const isExternal = data.target.options.point.origem === "externo";
      const isDefesaCivil = data.target.options.point.origem === "defesacivil";
      // O aside externo é outro componente: precisa existir no DOM antes de ser chamado.
      this.selectedIsExternal = isExternal;
      this.selectedIsDefesaCivil = isDefesaCivil;
      // Clicar num pin substitui o aviso no painel: o v-else-if do aviso vem antes de todos
      // os outros, então sem zerar aqui o painel continuaria mostrando o aviso anterior.
      this.avisoInmetSelecionado = null;
      if (this.$refs.map && this.$refs.map.setPolygonSelecionado) {
        this.$refs.map.setPolygonSelecionado(null);
      }

      // Dispositivos e estações públicas usam "nome + cidade/UF" no cabeçalho; o clima
      // usa "nome / UF" porque o ponto é a própria cidade.
      if (this.menuType == "estacao" || this.menuType == "publico") {
        this.$refs.aside.fadeIn(
          [data.target.options.point.nome, data.target.options.point.county] );
      } else {
        this.$refs.aside.fadeIn(
          [ data.target.options.point.uf
              ? data.target.options.point.nome + " / " + data.target.options.point.uf
              : data.target.options.point.nome, "" ]
        );
      }
      this.$refs.aside.footerButton = null;
      if (this.menuType == "clima") {
        this.rebuildAsideClima();
        this.$nextTick(() => {
          if (this.$refs.aside_clima) {
            this.$refs.aside_clima.getDataFirstRender(
              data.target.options.point.cidade_id,
              data.target.options.point.data
            );
          }
        });
      } else if (isDefesaCivil) {
        // v-if trocou o componente do slot: espera o próximo tick para o ref existir.
        this.$nextTick(() => {
          if (this.$refs.aside_defesacivil) {
            this.$refs.aside_defesacivil.load(data.target.options.point);
          }
        });
      } else if (isExternal) {
        // v-if trocou o componente do slot: espera o próximo tick para o ref existir.
        this.$nextTick(() => {
          if (this.$refs.aside_externo) {
            this.$refs.aside_externo.load(data.target.options.point);
          }
        });
      } else {
        this.$refs.aside_estacao.isPublicOnly = data.target.options.point.publico && !data.target.options.point.acessoCompleto;
        this.$refs.aside_estacao.bateriaOnConnect = data.target.options.point.bateriaOnConnect || null;
        this.$refs.aside_estacao.propriedadeAgricolaId = data.target.options.point.propriedadeAgricolaId || null;
        this.$refs.aside_estacao.propriedadeNome = data.target.options.point.propriedadeNome || null;
        this.$refs.aside_estacao.nomeDispositivo = data.target.options.point.nomeDispositivo || data.target.options.point.nome || null;
        this.$refs.aside_estacao.isSharedDevice = data.target.options.point.compartilhado || false;
        this.$refs.aside_estacao.isViewOnly = data.target.options.point.somenteVisualizacao || false;
        this.$refs.aside_estacao.getDataFirstRender(
          data.target.options.point.qrcodeid,
          data.target.options.point.data
        );
        if (data.target.options.point.detalhado && data.target.options.point.acessoCompleto !== false) {
          this.$refs.aside.footerButton = {
            name: "Dados detalhados",
            icon: "fa fa-circle-info",
          };
          this.$refs.aside.$forceUpdate();
        }
      }
      this.selectedPoint = data.target.options.point;
      // Atualizar os pontos no mapa para refletir a seleção
      this.updatePontos();
    },
    getClimaValueFormat(v) {
      if (this.menuType == "clima") {
        switch (this.climaType) {
          case "umidade": {
            return v.format(0, 0) + "%";
          }
          case "temperatura": {
            return v.format(0, 0) + "º";
          }
          default: {
            return v.format(0, 1);
          }
        }
      } else {
        switch (this.estacaoType) {
          case "umidade_media": {
            return v.format(0, 0) + "%";
          }
          case "temperatura_media": {
            return v.format(0, 0) + "º";
          }
          default: {
            return v.format(0, 1);
          }
        }
      }
    },
    // Cor do badge de um dispositivo conforme o status: verde online, cinza offline.
    getDeviceColor(device) {
      return device.status === StatusEnum.Online ? "#0A8F3C" : "#9e9e9e";
    },
    // Linha da lista do cluster (badge colorido por status + ícone + nome do
    // tipo de sensor + valor do sensor primário).
    getClusterRow(device) {
      // Dispositivo de terceiros: não tem sensor do catálogo nem status Online/Offline —
      // usa a cor do status de cheia e o valor já formatado pelo backend.
      if (device.origem === "externo") {
        const corExt = this.getExternalTrend(device).cor;
        const valorExt = device.pinValue != null
          ? String(device.pinValue).replace(".", ",") + (device.pinUnit ? " " + device.pinUnit : "")
          : "";
        return (
          '<div class="pin-cluster-row">' +
          '<div class="pin-expanded-badge" style="background-color: ' + corExt + ';">' +
          '<i class="fa fa-water" style="color:#fff;font-size:13px;"></i>' +
          "</div>" +
          '<div class="pin-expanded-info">' +
          '<span class="pin-expanded-name">' + (device.nome || "") + "</span>" +
          '<span class="pin-expanded-value">' + valorExt + "</span>" +
          "</div>" +
          "</div>"
        );
      }

      const sensor = (device.sensors && device.sensors[0]) || null;
      const sensorType = sensor ? sensor.sensorType : device.pinSensorType;
      const iconUrl = this.getSensorIconUrl(sensorType);
      const name = device.nome || this.getSensorTypeName(sensorType);
      var value = "";
      if (sensor) {
        value = this.formatPinValue(sensor.value) + sensor.unit;
      } else if (device.pinValue != null) {
        value = this.formatPinValue(device.pinValue) + (device.pinUnit || "");
      }
      const color = this.getDeviceColor(device);
      return (
        '<div class="pin-cluster-row">' +
        '<div class="pin-expanded-badge" style="background-color: ' + color + ';">' +
        this.maskIconHtml(iconUrl, "#ffffff", 22, "pin-expanded-icon") +
        "</div>" +
        '<div class="pin-expanded-info">' +
        '<span class="pin-expanded-name">' + name + "</span>" +
        '<span class="pin-expanded-value">' + value + "</span>" +
        "</div>" +
        "</div>"
      );
    },
    // Marker de cluster: pin compacto ("grupo de sensores" + N dispositivos) +
    // card expandido rolável (hover/long-press). Clique dá zoom para separar.
    addCluster(cluster, map) {
      const total = cluster.points.length;
      const compact =
        '    <div class="square-pin-icon-container pin-cluster-compact pin-cluster-static"> ' +
        '        <div class="pin-cluster-compact-body"> ' +
        '            <div class="pin-cluster-badge">' + total + "</div> " +
        '            <span class="pin-cluster-count">dispositivos</span> ' +
        "        </div> " +
        "    </div> ";
      const listHtml = cluster.points.map((d) => this.getClusterRow(d)).join("");
      const expanded =
        '    <div class="square-pin-expanded square-pin-cluster-card pin-cluster-static"> ' +
        '        <div class="pin-expanded-body pin-cluster-body"> ' +
        '            <div class="pin-cluster-list">' + listHtml + "</div> " +
        "        </div> " +
        '        <div class="pin-cluster-point"></div> ' +
        "    </div> ";
      const htmlIcon =
        '<div class="square-pin-icon has-expand is-cluster" title="' + total + ' dispositivos"> ' +
        compact +
        expanded +
        '    <div class="square-pin-icon-point"></div> ' +
        "</div>";

      const marker = map.addMarkerWithDivIcon(
        cluster.latitude,
        cluster.longitude,
        htmlIcon
      );
      if (marker) {
        // Clique no cluster → dar zoom para separar os pins.
        marker.addClickListener(() => {
          const z = this.$refs.map.getZoom();
          this.$refs.map.move(cluster.latitude, cluster.longitude, Math.min(z + 3, 20));
        });
      }
      return marker;
    },
    // Cor do pin de dispositivo externo pelo status de cheia informado pela fonte.
    // "desconhecida" = a fonte não tem níveis de referência para classificar (ex.: TideSat).
    // Mesmas cores das faixas no aside (NIVEL_CORES em NewAsideExternalDevice.vue).
    // Os tons são bem separados no espectro porque num pin pequeno amarelo/laranja/
    // vermelho-escuro eram quase indistinguíveis.
    getExternalStatusColor(statusCheia) {
      switch ((statusCheia || "").toLowerCase()) {
        case "inundacao": return "#d81b60"; // magenta
        case "alerta": return "#f57c00";    // laranja
        case "atencao": return "#f2c200";   // amarelo
        case "normal": return "#1e9e4a";    // verde
        default: return "#9e9e9e";          // cinza — sem referência
      }
    },

    getExternalStatusLabel(statusCheia) {
      switch ((statusCheia || "").toLowerCase()) {
        case "inundacao": return "Inundação";
        case "alerta": return "Alerta";
        case "atencao": return "Atenção";
        case "normal": return "Normal";
        default: return "Sem referência";
      }
    },

    // Tendência do dado → cor do badge + ícone. Subindo é o sinal de risco numa cheia
    // (vermelho); descendo é alívio (verde); estável, neutro (azul). Offline vence tudo:
    // sem leitura recente, a última tendência conhecida não significa mais nada.
    getExternalTrend(point) {
      if (point.offline) {
        return { cor: "#9e9e9e", capsula: "#9e9e9e", icone: "close", label: "Sem comunicação" };
      }

      switch ((point.nivelTendencia || "").toLowerCase()) {
        case "subindo":
          return { cor: "#e63946", capsula: "#e8710a", icone: "up", label: "Subindo" };
        case "descendo":
          return { cor: "#5c9c3e", capsula: "#e8710a", icone: "down", label: "Descendo" };
        case "estavel":
          return { cor: "#1e90ff", capsula: "#e8710a", icone: "flat", label: "Estável" };
        default:
          return { cor: "#9e9e9e", capsula: "#e8710a", icone: "flat", label: "Sem tendência" };
      }
    },

    // Ícone do badge em SVG (herda currentColor). Setas diagonais como no design.
    getExternalTrendSvg(tipo) {
      const wrap = (inner) =>
        '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="#fff" ' +
        'stroke-width="3" stroke-linecap="round" stroke-linejoin="round">' + inner + "</svg>";

      switch (tipo) {
        case "up":   return wrap('<path d="M7 17L17 7"/><path d="M9 7h8v8"/>');
        case "down": return wrap('<path d="M7 7l10 10"/><path d="M17 9v8H9"/>');
        case "flat": return wrap('<path d="M6 12h12"/>');
        case "close":return wrap('<path d="M7 7l10 10"/><path d="M17 7L7 17"/>');
        default:     return "";
      }
    },

    addExternalPin(point, map) {
      const isSelected = this.selectedPoint && this.selectedPoint.id === point.id;
      const trend = this.getExternalTrend(point);

      const valor = point.pinValue != null ? point.pinValue : "--";
      const unidade = point.pinUnit || "";
      // "16,5 m" — vírgula decimal, como no restante da interface em pt-BR.
      const texto = String(valor).replace(".", ",") + (unidade ? " " + unidade : "");

      const titulo = point.nome
        + (point.rio ? " — Rio " + point.rio : "")
        + " · " + trend.label
        + (point.offline ? "" : " (" + this.getExternalStatusLabel(point.statusCheia) + ")");

      const htmlIcon =
        '<div class="external-pin' + (isSelected ? " is-selected" : "") + '" title="' + titulo + '">' +
        '  <div class="external-pin-capsule">' +
        '    <span class="external-pin-value" style="background:' + trend.capsula + ';">' + texto + "</span>" +
        '    <span class="external-pin-badge" style="background:' + trend.cor + ';">' +
        this.getExternalTrendSvg(trend.icone) +
        "    </span>" +
        "  </div>" +
        '  <div class="external-pin-stem"></div>' +
        "</div>";

      const marker = map.addMarkerWithDivIcon(point.latitude, point.longitude, htmlIcon);
      if (!marker) return;

      marker.addClickListener(() => {
        this.clickClima({
          latlng: { lat: point.latitude, lng: point.longitude },
          target: {
            options: { point: point, icon: { options: { html: htmlIcon } } },
            getIcon: () => ({ options: { html: htmlIcon } }),
            setIcon: () => {},
          },
        });
      });
    },

    add(point, markerGroup, map) {
      // Cluster de dispositivos sobrepostos.
      if (point.isCluster) {
        this.addCluster(point, map);
        return;
      }

      // Camada da Defesa Civil: pin próprio, mostrando a grandeza escolhida no botão
      // lateral. Vem antes do ramo de terceiros porque é outra origem, com outro pin.
      if (point.origem === "defesacivil") {
        this.addDefesaCivilPin(point, map);
        return;
      }

      // Dispositivo de terceiros: pin próprio, colorido pelo status de cheia (que é a
      // informação que importa nessas estações), não pelas escalas de sensor do OnAgro.
      if (point.origem === "externo") {
        this.addExternalPin(point, map);
        return;
      }

      var r = 75, g = 180, b = 21;

      const isSpecialStation = point.qrcodeid === 1;
      if (isSpecialStation) {
        // Cor azul fixa para estação ID 1
        r = 139;
        g = 205;
        b = 236;
      } else {
        // Lógica de cores baseada no valor
        var valor = parseFloat(point[this.getType()]);

        // Para dispositivos sem estação, usar cor baseada no sensor ativo
        if (this.menuType === "estacao" && point.pinSensorType && point.pinSensorType !== "estacao") {
          if (point.pinSensorType.startsWith("sonda")) {
            r = 0; g = 150; b = 200; // Azul para sondas
          } else {
            r = 75; g = 180; b = 21; // Verde padrão para outros
          }
        } else if (this.menuType == "clima") {
          // Usar gradiente de cores para o mapa de clima
          const scale = this.getClimaColorScale(this.climaType);
          const color = this.getGradientColor(valor, scale);
          r = color.r;
          g = color.g;
          b = color.b;
        } else {
          // Lógica para estações (mantém a lógica existente)
          if (this.estacaoType == "temperatura_media") {
            // Usar o mesmo gradiente de temperatura para estações
            const scale = this.getClimaColorScale('temperatura');
            const color = this.getGradientColor(valor, scale);
            r = color.r;
            g = color.g;
            b = color.b;
          } else {
            var m = valor;
            if (m > 150) {
              m = 150;
            }
            switch (this.estacaoType) {
              case "vento_velocidade_media": {
                m *= 5;
                r = 150 + m; g = 150 - m; b = 150 - m;
                break;
              }
              case "umidade_media": {
                m *= 1;
                r = 150 - m; g = 150 - m; b = 150 + m;
                break;
              }
              default: {
                m *= 15;
                r = 150 - m; g = 150 - m; b = 150 + m;
              }
            }
          }
        }
      }

      // Lógica para ponto selecionado (mantém a mesma, mas não afeta estação especial)
      if (this.selectedPoint && point.id == this.selectedPoint.id && !isSpecialStation) {
        if (this.menuType == "clima") {
          if (this.climaType == "precipitacao_prevista" || this.climaType == "umidade") {
            r = 255; g = 0; b = 0;
          } else {
            r = 0; g = 0; b = 255;
          }
        } else {
          if (this.estacaoType == "precipitacao_soma" || this.estacaoType == "umidade_media") {
            r = 255; g = 0; b = 0;
          } else {
            // Estação selecionada: verde #006035
            r = 0; g = 96; b = 53;
          }
        }
      }

      const isPublicOnly = point.publico && !point.acessoCompleto;
      const hasSensors =
        this.menuType === "estacao" && point.sensors && point.sensors.length > 0;
      const isOffline =
        this.menuType === "estacao" && point.status !== StatusEnum.Online;
      const isSelected =
        this.selectedPoint && point.id == this.selectedPoint.id && !isSpecialStation;

      // Conteúdo interno do pin: para estações com sensores, alterna ícone/valor
      // (getSensorPinContent); caso contrário, mostra o valor formatado.
      var innerContent;
      if (isSpecialStation) {
        innerContent = "";
      } else if (hasSensors) {
        innerContent = this.getSensorPinContent(
          point,
          this.sensorRotationIndex,
          isPublicOnly
        );
      } else {
        const displayText = this.getClimaValueFormat(point[this.getType()]);
        const textColor = isPublicOnly ? "color: #333333;" : "";
        innerContent =
          '<span class="square-pin-icon-text" data-pin-qr="' +
          point.qrcodeid +
          '" style="' + textColor + '">' +
          displayText +
          "</span>";
      }

      // Define a cor de fundo e as classes de estado do pin.
      var bgStyle;
      var stateClass = "";
      if (hasSensors) {
        // Estação com sensores: cor segue o sensor exibido (escala por valor),
        // cinza se offline, verde se selecionado, branco se público.
        bgStyle = this.getStationPinBgStyle(point, this.sensorRotationIndex);
        if (isPublicOnly) {
          // sem borda de status
        } else if (isOffline) {
          stateClass = " pin-offline";
        } else {
          stateClass = " pin-online";
        }
      } else if (isPublicOnly) {
        bgStyle = "background-color: #E8F8E6;"; // verde claro
      } else if (isOffline) {
        bgStyle = isSelected
          ? "background-color: rgb(" + r + "," + g + "," + b + ");"
          : "background-color: #c7c7c7;";
        stateClass = " pin-offline";
      } else {
        // Clima / demais: cor calculada pelo dado (r,g,b acima).
        bgStyle = "background-color: rgb(" + r + "," + g + "," + b + ");";
        if (this.menuType == "estacao" && point.status == StatusEnum.Online) {
          stateClass = " pin-online";
        }
      }

      // Card expandido (hover/long-press) — só para estações com sensores.
      // Fundo do card branco; só o badge do ícone leva a cor do sensor.
      var expandedHtml = "";
      if (hasSensors) {
        expandedHtml =
          '    <div class="square-pin-expanded' + stateClass + '"> ' +
          '        <div class="pin-expanded-body">' +
          this.getSensorExpandedContent(point, this.sensorRotationIndex, bgStyle) +
          "        </div> " +
          "    </div> ";
      }

      var htmlIcon =
        '<div class="square-pin-icon' + (isPublicOnly ? " public-station" : "") + (hasSensors ? " has-expand" : "") + (isSelected ? " is-selected" : "") + '" title="' + point.nome + '"> ' +
        '    <div class="square-pin-icon-container' + stateClass + '"> ' +
        '        <div class="square-pin-icon-text-container" style="' + bgStyle + '"> ' +
        innerContent +
        "        </div> " +
        "    </div> " +
        expandedHtml +
        '    <div class="square-pin-icon-point"></div> ' +
        "</div>";

      // Bateria (barra vertical) ao lado do pin — só para estações com acesso completo.
      if (this.menuType == "estacao" && point.bateriaOnConnect && !isPublicOnly) {
        const batteryPercentage = this.getBatteryPercentage(point.bateriaOnConnect);
        // Offline: bateria cinza; online: cor por nível de carga.
        const batteryColor = isOffline ? "#9e9e9e" : this.getBatteryColor(point.bateriaOnConnect);
        const fillHeight = Math.max(10, batteryPercentage); // % de preenchimento (min visível)

        htmlIcon +=
          '<div class="battery-map-bar">' +
          '<div class="battery-map-bar-fill" style="height: ' + fillHeight + '%; background: ' + batteryColor + ';"></div>' +
          "</div>";
      }

      // Usar Google Maps ao invés de Leaflet
      const marker = map.addMarkerWithDivIcon(
        point.latitude,
        point.longitude,
        htmlIcon
      );

      if (marker) {
        // Guardar referência para alternância ícone/valor (qualquer estação com sensores).
        if (this.menuType === "estacao" && point.sensors && point.sensors.length > 0) {
          this.multiSensorMarkers.push({ marker, point });
        }
        // Usar o método addClickListener que funciona tanto antes quanto depois do div estar pronto
        marker.addClickListener(() => {
          this.clickClima({
            latlng: { lat: point.latitude, lng: point.longitude },
            target: {
              options: {
                point: point,
                icon: {
                  options: {
                    html: htmlIcon
                  }
                }
              },
              getIcon: () => ({ options: { html: htmlIcon } }),
              setIcon: () => {}
            }
          });
        });
      }
    },
    setPontos(type = this.menuType, load = true) {
      // Cada chamada recebe um id. Só a MAIS RECENTE pode escrever em this.pontos.
      //
      // Sem isso, trocar de modo rápido causava dois defeitos: (a) a resposta lenta de um
      // modo anterior chegava depois e limpava/pintava o mapa do modo atual; (b) o clique
      // no switch dispara setPontos duas vezes (v-model do menuType + watcher da rota),
      // gerando duas requisições concorrentes para o mesmo modo.
      const requestId = ++this.pontosRequestId;
      const ehAtual = () => requestId === this.pontosRequestId && this.menuType === type;

      this.pontos = null;
      this.updatePontos();
      this.loadMap = load;
      clearInterval(this.climaAutoUpdate);
      clearInterval(this.estacaoAutoUpdate);
      clearInterval(this.publicoAutoUpdate);

      const aplicar = (dados, agendar) => {
        if (!ehAtual()) return; // resposta obsoleta: outro modo já assumiu
        this.pontos = dados;
        agendar();
        // updatePontos() por último e isolado: um erro ao DESENHAR não pode cair no
        // .catch() da requisição, que trataria falha de renderização como falha de rede
        // e descartaria pontos já recebidos. Foi assim que um TypeError de bounds
        // ausentes virou "mapa sem nenhum pin" em vez de um erro visível.
        try {
          this.updatePontos();
        } catch (err) {
          console.error("Erro ao desenhar pontos no mapa:", err);
        }
      };

      // loadMap só é desligado pela requisição vigente — senão uma resposta antiga
      // esconderia o loading enquanto a atual ainda está carregando.
      const finalizar = () => {
        if (requestId === this.pontosRequestId) this.loadMap = false;
      };

      if (type == "clima") {
        this.getClimaPontos()
          .then((e) => {
            aplicar(e.data, () => {
              this.climaAutoUpdate = setInterval(() => {
                this.setPontos(this.menuType, false);
              }, 60000 * 10);
            });
          })
          .catch((err) => {
            console.error("Erro ao carregar previsão:", err);
          })
          .finally(finalizar);
      } else if (type == "publico") {
        // Duas camadas independentes: as estações de terceiros (sempre) e a rede da
        // Defesa Civil (só se o botão estiver ligado). Cada uma guarda seus pontos, e
        // aplicarPontosPublico soma as duas — ligar/desligar a segunda não recarrega a
        // primeira.
        //
        // As fontes de terceiros coletam a cada 32-45 min e o backend cacheia por 5 min;
        // as estações da Defesa Civil transmitem a cada 10-15 min. Um ciclo de 5 minutos
        // acompanha as duas sem martelar nenhuma origem.
        Promise.all([
          this.getPublicoPontos()
            .then((e) => (e && e.data) || [])
            .catch((err) => {
              console.error("Erro ao carregar estações públicas:", err);
              return [];
            }),
          this.defesaCivilAtivo && this.podeVerDefesaCivil
            ? this.getDefesaCivilPontos()
                .then((e) => (e && e.data) || [])
                .catch((err) => {
                  console.error("Erro ao carregar estações da Defesa Civil:", err);
                  return [];
                })
            : Promise.resolve([]),
        ])
          .then(([publicos, defesaCivil]) => {
            if (!ehAtual()) return; // resposta obsoleta: outro modo já assumiu
            this.pontosPublico = publicos;
            this.pontosDefesaCivil = defesaCivil;
            aplicar(publicos.concat(defesaCivil), () => {
              this.publicoAutoUpdate = setInterval(() => {
                this.setPontos(this.menuType, false);
              }, 60000 * 5);
            });

            // Os avisos vêm fora deste fluxo por não serem pontos — não entram em
            // this.pontos nem passam por aplicar(). O ciclo de 5 min acima também os
            // renova, e sem custo para o INMET: quem fala com eles é o coletor do backend.
            this.carregarInmet();
          })
          .finally(finalizar);
      } else {
        this.getEstacaoPontos()
          .then((e) => {
            aplicar(e.data, () => {
              this.estacaoAutoUpdate = setInterval(() => {
                this.setPontos(this.menuType, false);
              }, 60000);
            });
          })
          .catch((err) => {
            console.error("Erro ao carregar dispositivos:", err);
          })
          .finally(finalizar);
      }
    },
  },
  mounted() {
    this.carregarDisponibilidadeExterna();
    this.carregarDisponibilidadeDefesaCivil();
    this.carregarDisponibilidadeInmet();

    // O watcher de $route.query.map (immediate) já resolveu o menuType a partir da rota —
    // não repetir aqui, para não haver duas fontes escrevendo o mesmo estado.
    if (!this.$route.query.map) {
      this.$router.push({ path: '/', query: { map: 'estacao' } });
    }

    this.$refs.map.event = {
      add: this.add,
      move: this.move,
    };

    // O watcher roda antes do mounted, quando $refs.map ainda não existe e o updatePontos
    // dele não tem onde desenhar. Esta é a primeira carga que efetivamente pinta o mapa.
    this.setPontos();
    this.sensorRotationInterval = setInterval(() => {
      this.sensorRotationIndex++;
      this.updatePinTexts();
    }, 1500);
  },
  beforeUnmount() {
    clearInterval(this.climaAutoUpdate);
    clearInterval(this.estacaoAutoUpdate);
    clearInterval(this.publicoAutoUpdate);
    clearInterval(this.sensorRotationInterval);
  },
  watch: {
    climaType() {
      this.updatePontos();
    },
    estacaoType() {
      this.updatePontos();
    },
    agruparPins(valor) {
      try {
        localStorage.setItem(AGRUPAR_PINS_KEY, String(valor));
      } catch (e) {
        // sem storage: a escolha vale só nesta sessão
      }
      this.updatePontos();
    },

    // Trocar a grandeza só muda o que o pin escreve — os pontos já estão em memória.
    defesaCivilGrandeza() {
      if (this.menuType === "publico") this.updatePontos();
    },

    // Ligar busca a camada (uma vez); desligar apenas some com ela — os pontos ficam em
    // memória para religar sem nova requisição, e o ciclo de 5 min os renova.
    defesaCivilAtivo(ativo) {
      if (this.menuType !== "publico") return;

      if (!ativo) {
        // Um ponto da camada podia estar selecionado com o painel aberto.
        if (this.selectedIsDefesaCivil) {
          if (this.$refs.aside) this.$refs.aside.show = false;
          this.selectedPoint = null;
          this.selectedIsDefesaCivil = false;
        }
        this.aplicarPontosPublico();
        return;
      }

      if (this.pontosDefesaCivil && this.pontosDefesaCivil.length) {
        this.aplicarPontosPublico();
        return;
      }

      this.carregarDefesaCivil();
    },

    // Ligar busca os avisos; desligar apaga os polígonos e fecha o painel se havia um aviso
    // aberto. Diferente da Defesa Civil, religar SEMPRE rebusca: a chamada não custa nada ao
    // INMET (o backend serve de cache) e um aviso pode ter sido emitido ou encerrado desde a
    // última vez — segurar um aviso vencido na tela é pior do que uma request a mais.
    inmetAtivo(ativo) {
      if (this.menuType !== "publico") return;

      if (!ativo) {
        this.fecharAvisoInmet();
        this.desenharAvisosInmet();
        return;
      }

      this.carregarInmet();
    },
    menuType() {
      if (this.$refs.aside_clima && this.$refs.aside_clima.grafico) {
        this.$refs.aside_clima.grafico.destroy();
        this.$refs.aside_clima.grafico = null;
      }
      if (this.$refs.aside) {
          this.$refs.aside.show = false;
      }
      // Trocar de modo invalida a seleção: sem isso o aside externo continuaria montado
      // ao voltar para Dispositivos.
      this.selectedPoint = null;
      this.selectedIsExternal = false;
      this.selectedIsDefesaCivil = false;

      // Os polígonos do INMET são de outra camada e não seriam removidos pelo redesenho de
      // pontos: sem isto, sair de "Público" deixaria as manchas de aviso sobre os outros
      // mapas. Aqui só se apaga do mapa — o toggle e os dados seguem em memória, para a
      // camada voltar como estava ao retornar para "Público".
      this.avisoInmetSelecionado = null;
      if (this.$refs.map && this.$refs.map.clearPolygons) {
        this.$refs.map.clearPolygons();
      }

      // No boot este watcher roda antes do mounted, quando o mapa ainda não existe —
      // a primeira carga fica por conta do mounted.
      if (this.$refs.map) this.setPontos();
    },
    "$route.query.map": {
      handler(value) {
        const alvo = value || "estacao";
        // ?map=publico digitado à mão por quem não tem acesso cairia num mapa vazio.
        // Mas no F5 este watcher (immediate) roda ANTES de /Availability responder, quando
        // temDispositivosExternos ainda é false por não ter carregado — não por falta de
        // acesso. Rebaixar aqui prendia quem tem acesso em "estacao" com a rota em
        // ?map=publico (menu lateral certo, switch e mapa errados). Enquanto a permissão é
        // desconhecida aceitamos a rota; carregarDisponibilidadeExterna corrige depois se
        // o usuário de fato não tiver acesso.
        const permitido =
          this.disponibilidadeExternaCarregada === false ||
          this.menuBotoesVisiveis.some((b) => b.value === alvo);
        this.menuType = permitido ? alvo : "estacao";
      },
      immediate: true, // Executa no carregamento inicial
    },
  },
};
</script>

<style>
.leaflet-right .leaflet-control {
  margin-top: 50px !important;
}
.map-load {
  position: absolute;
  z-index: 1100;
  display: flex;
  width: 100%;
  height: 100%;
  background-color: #97979788;
  pointer-events: all;
}
.card-info {
  min-height: 188px;
}
.dash-proccess {
  max-height: 350px;
  overflow-y: auto;
}
.btn-mapa {
  height: 48px;
  width: 48px;
  margin-bottom: 10px;
  border-radius: 10%;
  font-size: 22px;
  outline-width: 0;
  border: 2px solid #b1b1b1;
  color: #b1b1b1;
  padding: 1px;
  display: flex;
  pointer-events: all;
}
.btn-mapa.inline {
  display: inline-flex;
  margin-right: 10px;
}
.btn-mapa svg {
  display: flex;
  margin: auto;
  font-size: 25px;
}
.btn-mapa.active {
  background-color: #006035;
  color: #fff;
  border-color: #006035;
}
.div-btn-mapa-bottom {
  position: absolute;
  display: flex;
  z-index: 1000;
  left: 10px;
  bottom: 15px;
  width: calc(100% - 10px);
}

/* ===== Camada de avisos do INMET ===== */

/* Laranja de alerta em vez do verde padrão do .btn-mapa.active: o botão liga uma camada de
   AVISO, e a cor precisa dizer isso mesmo antes de o usuário ler o tooltip. */
.btn-mapa-inmet.active {
  background-color: #e07b00;
  border-color: #e07b00;
  color: #fff;
}

/* Canto oposto aos botões (que ficam à esquerda) e acima da barra de modos, para não cobrir
   nem ser coberta por eles. */
.inmet-legenda {
  position: absolute;
  z-index: 1000;
  right: 10px;
  bottom: 15px;
  background: #ffffff;
  border-radius: 8px;
  padding: 10px 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  font-size: 12px;
  color: #2f3b2a;
  pointer-events: all;
  /* Cresce com o conteúdo até um teto, em vez de largura fixa: com 5 ou 6 dias as abas
     precisam de mais espaço, e travar em 268px as espremia. O max-width com vw impede que
     o card encoste nas bordas no celular. */
  min-width: 240px;
  max-width: min(340px, calc(100vw - 20px));
}
.inmet-legenda-titulo {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 700;
  margin-bottom: 8px;
  color: #e07b00;
}
/* Fila de abas de dia.
   Rola na horizontal em vez de dividir o espaço em partes iguais: dividir funcionava com 3
   dias, mas o INMET às vezes publica 5 ou 6, e aí cada aba ficava estreita demais para o
   rótulo ("Hoj", "A...", "S..."). Com largura natural cada aba mostra o texto inteiro, e as
   que não couberem ficam a um arrasto de distância. */
.inmet-dias {
  display: flex;
  gap: 4px;
  padding-bottom: 6px;
  margin-bottom: 8px;
  border-bottom: 1px solid #eee;
  overflow-x: auto;
  /* A barra de rolagem nativa comeria a altura do card num espaço já apertado. */
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.inmet-dias::-webkit-scrollbar { display: none; }
.inmet-dia {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  /* Largura do conteúdo, sem encolher: é o que garante o rótulo inteiro em cada aba. */
  flex: 0 0 auto;
  white-space: nowrap;
  background: #f2f2f2;
  border: 1px solid transparent;
  border-radius: 6px;
  padding: 4px 4px;
  font-size: 11px;
  color: #5a5a5a;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.inmet-dia-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.inmet-dia:hover {
  background: #e6e6e6;
}
.inmet-dia.active {
  background: #e07b00;
  border-color: #e07b00;
  color: #fff;
  font-weight: 700;
}
.inmet-dia-qtd {
  background: rgba(0, 0, 0, 0.12);
  border-radius: 999px;
  padding: 0 4px;
  font-size: 10px;
  font-weight: 700;
  flex-shrink: 0;
}
.inmet-dia.active .inmet-dia-qtd {
  background: rgba(255, 255, 255, 0.3);
}
.inmet-legenda-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}
/* Borda escura porque o amarelo do "Perigo Potencial" some sobre o fundo branco do card. */
.inmet-legenda-cor {
  width: 14px;
  height: 14px;
  border-radius: 3px;
  border: 1px solid rgba(0, 0, 0, 0.25);
  flex-shrink: 0;
}
/* Espelha o polígono do aviso futuro: sem preenchimento, só o contorno. */
.inmet-legenda-cor.is-futuro {
  background: transparent;
  border: 2px solid #7a7a7a;
}
.inmet-legenda-futuro {
  color: #7a7a7a;
}
.inmet-legenda-label {
  flex: 1;
}
.inmet-legenda-qtd {
  font-weight: 700;
}
.inmet-legenda-vazio,
.inmet-legenda-hora {
  color: #7a7a7a;
}
.inmet-legenda-hora {
  margin-top: 8px;
  font-size: 11px;
}
.inmet-legenda-degradado {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  padding-top: 6px;
  border-top: 1px solid #eee;
  color: #c62828;
  font-size: 11px;
}

/* ===== Botão de agrupar pins (ao lado do Terreno/Satélite, mesmo desenho) ===== */
.btn-agrupar {
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 50%;
  background: #ffffff;
  color: #999999;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  pointer-events: all;
  transition: all 0.3s ease;
}
.btn-agrupar:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  color: #78a64e;
}
.btn-agrupar.active {
  background: #78a64e;
  color: #ffffff;
}
@media (max-width: 767px) {
  .btn-agrupar {
    width: 36px;
    height: 36px;
    font-size: 15px;
  }
}

/* ===== Toggle Dispositivos/Previsão (mesmo design do Terreno/Satélite) ===== */
.map-mode-toggle {
  display: flex;
  background: #ffffff;
  border-radius: 30px;
  padding: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  pointer-events: all;
  cursor: pointer;
  transition: box-shadow 0.3s ease;
}
.map-mode-toggle:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}
.map-mode-option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 26px;
  background: #ffffff;
  color: #999999;
  cursor: pointer;
  justify-content: center;
  transition: all 0.3s ease;
}
/* Opção inativa: só ícone — quadrada e compacta (sem min-width forçando vão). */
.map-mode-option:not(.active) {
  width: 38px;
  padding: 8px;
}
.map-mode-option.active {
  background: #78a64e;
  color: #ffffff;
  padding: 8px 16px;
}
/* O LogoIcon mescla esta classe no seu <div> raiz, que tem classes Bootstrap
   (w-100/h-100/p-1/m-auto). Sobrescreve com !important para conter a 20px. */
.map-mode-icon {
  flex: 0 0 auto;
  width: 20px !important;
  height: 20px !important;
  font-size: 20px;
  padding: 0 !important;
  margin: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.map-mode-icon .logo-icon {
  width: 20px;
  height: 20px;
}
.map-mode-label {
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
}

/* ===== Mobile: alvo de toque maior =====
   No desktop a opção inativa é um quadrado de 38x36px, mirado com o mouse. No celular
   isso fica abaixo dos 44px que iOS e Android recomendam como área mínima de toque, e
   quem tem dedo maior erra o botão. Aqui as opções passam a 48px e o ícone acompanha. */
@media (max-width: 768px) {
  .div-btn-mapa-bottom {
    bottom: 20px;
  }

  /* No celular a barra de modos é bem mais alta (botões de 48px) e a legenda, ancorada em
     bottom:15px, ficava por cima dela — na prática cobrindo o seletor "Público". Sobe a
     legenda para acima da barra e a deixa ocupar a largura útil da tela. */
  .inmet-legenda {
    bottom: 90px;
    left: 10px;
    right: 10px;
    max-width: none;
    min-width: 0;
    font-size: 13px;
  }

  /* Alvos de toque maiores: 4px de padding é confortável no mouse, não no dedo. */
  .inmet-dia {
    padding: 7px 10px;
    font-size: 12px;
  }

  .map-mode-toggle {
    padding: 5px;
    border-radius: 34px;
  }

  .map-mode-option {
    gap: 10px;
    padding: 12px 14px;
    border-radius: 30px;
  }

  .map-mode-option:not(.active) {
    width: 48px;
    padding: 12px;
  }

  .map-mode-option.active {
    padding: 12px 20px;
  }

  .map-mode-icon {
    width: 24px !important;
    height: 24px !important;
    font-size: 24px;
  }

  /* !important porque PublicIcon define 1.25rem no seu <style scoped>, cuja
     especificidade (atributo data-v) vence este seletor global. */
  .map-mode-icon .logo-icon,
  .map-mode-icon .public-icon {
    width: 24px !important;
    height: 24px !important;
  }

  .map-mode-label {
    font-size: 15px;
  }
}
.div-btn-mapa {
  position: absolute;
  z-index: 1000;
  right: 10px;
  top: 108px;
}
/* ===== Estado online: borda verde animada girando ===== */
.pin-online {
  position: relative;
  z-index: 0;
  overflow: hidden;
}
.pin-online::before {
  content: "";
  position: absolute;
  z-index: -2;
  /* Quadrado FIXO grande, centralizado: cobre o card mesmo largo/retangular ao
     girar (sem depender de aspect-ratio). Fica atrás e é clipado por overflow. */
  top: 50%;
  left: 50%;
  width: 320px;
  height: 320px;
  transform: translate(-50%, -50%);
  transform-origin: center;
  background-color: #399953;
  background-repeat: no-repeat;
  background-size: 50% 50%, 50% 50%;
  background-position: 0 0, 100% 0, 100% 100%, 0 100%;
  background-image: linear-gradient(#25a80b, #25a80b),
    linear-gradient(#4ed533, #4ed533), linear-gradient(#25a80b, #25a80b),
    linear-gradient(#4ed533, #4ed533);
  -webkit-animation: rotateCentered 2s linear infinite;
  animation: rotateCentered 2s linear infinite;
}
@-webkit-keyframes rotate {
  100% {
    transform: rotate(1turn);
  }
}
@keyframes rotate {
  100% {
    transform: rotate(1turn);
  }
}
/* Gira mantendo o centro (preserva o translate(-50%,-50%)). */
@-webkit-keyframes rotateCentered {
  from { transform: translate(-50%, -50%) rotate(0); }
  to   { transform: translate(-50%, -50%) rotate(1turn); }
}
@keyframes rotateCentered {
  from { transform: translate(-50%, -50%) rotate(0); }
  to   { transform: translate(-50%, -50%) rotate(1turn); }
}
.pin-online::after {
  content: "";
  position: absolute;
  z-index: -1;
  left: 3px;
  top: 3px;
  width: calc(100% - 6px);
  height: calc(100% - 6px);
  background: white;
  border-radius: 9px;
}

/* ===== Estado offline: borda cinza animada girando ===== */
.pin-offline {
  position: relative;
  z-index: 0;
  overflow: hidden;
}
.pin-offline::before {
  content: "";
  position: absolute;
  z-index: -2;
  top: 50%;
  left: 50%;
  width: 320px;
  height: 320px;
  transform: translate(-50%, -50%);
  transform-origin: center;
  background-color: #9e9e9e;
  background-repeat: no-repeat;
  background-size: 50% 50%, 50% 50%;
  background-position: 0 0, 100% 0, 100% 100%, 0 100%;
  background-image: linear-gradient(#8a8a8a, #8a8a8a),
    linear-gradient(#cfcfcf, #cfcfcf), linear-gradient(#8a8a8a, #8a8a8a),
    linear-gradient(#cfcfcf, #cfcfcf);
  -webkit-animation: rotateCentered 2s linear infinite;
  animation: rotateCentered 2s linear infinite;
}
.pin-offline::after {
  content: "";
  position: absolute;
  z-index: -1;
  left: 3px;
  top: 3px;
  width: calc(100% - 6px);
  height: calc(100% - 6px);
  background: white;
  border-radius: 9px;
}

/* ===== Bateria: barra vertical encostada na borda direita do pin =====
   Anexada como irmã de .square-pin-icon (mesmo overlay do marker), então as
   coordenadas seguem a origem do marker: o pin ocupa de left:-22px a +22px
   e top:-46px a -12px. A barra fica logo após a borda direita do pin. */
.battery-map-bar {
  position: absolute;
  left: 24px;
  top: -45px;
  width: 9px;
  height: 32px;
  background-color: rgba(0, 0, 0, 0.12);
  border: 2px solid #ffffff;
  border-radius: 5px;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  box-sizing: border-box;
}
.battery-map-bar-fill {
  width: 100%;
  border-radius: 3px;
  transition: height 0.3s ease, background 0.3s ease;
}

/* ===== Pin de dispositivo de terceiros (Defesa Civil / ANA / TideSat) =====
   Cápsula com o valor + badge circular com a tendência. A cor do badge é o que comunica:
   verde descendo, vermelho subindo, azul estável, cinza sem comunicação (aí a cápsula
   inteira acinzenta, porque o valor exibido está velho). */
.external-pin {
  position: relative;
  transform: translate(-50%, -100%);
  cursor: pointer;
}
.external-pin-capsule {
  display: flex;
  align-items: center;
  background: #ffffff;
  border-radius: 999px;
  padding: 3px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}
.external-pin.is-selected .external-pin-capsule {
  box-shadow: 0 0 0 2px #006035, 0 2px 6px rgba(0, 0, 0, 0.3);
}
.external-pin-value {
  display: block;
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
  padding: 6px 10px 6px 12px;
  border-radius: 999px 0 0 999px;
  font-variant-numeric: tabular-nums;
}
.external-pin-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  flex: 0 0 auto;
  margin-left: -6px;
  border: 2px solid #ffffff;
}
/* Haste ligando a cápsula ao ponto no mapa. */
.external-pin-stem {
  width: 3px;
  height: 12px;
  margin: -2px auto 0;
  background: #6b7a5e;
  border-radius: 0 0 2px 2px;
}

/* ===== Separador entre o botão da camada e os botões de grandeza =====
   Sem ele os sete botões viram uma coluna só e o toggle (que liga/desliga tudo) parece
   ser apenas mais uma grandeza. */
.btn-mapa-sep {
  height: 2px;
  width: 32px;
  margin: 0 auto 10px;
  background: rgba(0, 0, 0, 0.25);
  border-radius: 2px;
}

/* Botão da camada: quando ativo herda o verde de .btn-mapa.active; a borda mais forte
   no estado inativo o diferencia dos botões de grandeza logo abaixo. */
.btn-mapa-dc {
  border-color: #78a64e;
  color: #78a64e;
}

/* O brasão é colorido e tem áreas quase brancas. Sobre o fundo verde do estado .active
   elas sumiriam, então o botão da Defesa Civil mantém fundo claro nos dois estados e
   marca o "ligado" só pela borda — o ícone continua legível em ambos. */
.btn-mapa-dc,
.btn-mapa-dc.active {
  background-color: #ffffff;
}
.btn-mapa-dc.active {
  border-color: #006035;
}
/* Desligado o selo fica esmaecido, para o botão ativo se destacar sem trocar de cor. */
.btn-mapa-brasao {
  width: 34px;
  height: 34px;
  margin: auto;
  object-fit: contain;
  display: block;
  opacity: 0.55;
  transition: opacity 0.2s;
}
.btn-mapa-dc.active .btn-mapa-brasao {
  opacity: 1;
}

/* ===== Pin da camada da Defesa Civil (RS) =====
   Anatomia espelhada em relação ao pin de terceiros (.external-pin): lá o valor fica à
   esquerda e o badge à direita; aqui o badge (escudo) vem PRIMEIRO. As duas camadas
   aparecem juntas no mesmo mapa, então a assimetria é o que permite dizer de qual rede é
   cada ponto sem ler o rótulo. */
.dc-pin {
  position: relative;
  transform: translate(-50%, -100%);
  cursor: pointer;
}
.dc-pin-capsule {
  display: flex;
  align-items: center;
  background: #ffffff;
  border-radius: 999px;
  padding: 3px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}
.dc-pin.is-selected .dc-pin-capsule {
  box-shadow: 0 0 0 2px #006035, 0 2px 6px rgba(0, 0, 0, 0.3);
}
/* Sem transmitir: a cápsula inteira desbota, porque o número exibido é antigo. */
.dc-pin.is-offline .dc-pin-capsule {
  opacity: 0.65;
}
.dc-pin-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  flex: 0 0 auto;
  border: 2px solid #ffffff;
  margin-right: -6px;
  z-index: 1;
}
.dc-pin-value {
  display: flex;
  align-items: center;
  gap: 3px;
  color: #2f3b2a;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
  padding: 6px 12px 6px 12px;
  font-variant-numeric: tabular-nums;
}
.dc-pin-trend {
  display: inline-flex;
  align-items: center;
  color: #6b7a5e;
}
/* Haste ligando a cápsula ao ponto no mapa — pintada com a cor da grandeza, como o badge. */
.dc-pin-stem {
  width: 3px;
  height: 12px;
  margin: -2px auto 0;
  border-radius: 0 0 2px 2px;
}
</style>
